<template>
  <div>
    <div class="row">
      <div class="ordersposContainer">
        <div class="dispatch">
          <div class="col-orders">
            <div class="newOrder">
              <!-- <div class="buttonAdd">
                <button title="Add user" class="btn add mar-rt-10" @click="showOrdersPosModal">
                    <img src="/static/img/icons/add.png">
                    {{$t('menuLink.orderspos')}}
                </button>
              </div> -->
              <div class="buttonAdd batched">
                <button title="Add group order" class="btn add mar-rt-10" @click="showAddOrdersGroupModal">
                    <img src="/static/img/icons/add.png">
                    {{$t('dispath.addGroupOrder')}}
                </button>
              </div>
              <div class="filterLocation">
                <el-button type="default" class="filter-btn" @click="openFiltersModal">
                  <img src="/static/img/icons/filter.png">
                </el-button>
              </div>
            </div>
            <div class="dispatch-filters-content pad-to-10 text-bold-500" style="font-size: 13px; padding: 0 10px 10px;">
              <template v-if="hasActiveFilters">
                <div class="filters-header" @click="toggleFiltersCollapse">
                  <button class="collapse-toggle-btn" type="button">
                    <i :class="showFiltersCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-down'"></i>
                  </button>
                  <span>{{$t('orders.filtersApplied')}}:</span>
                </div>
                <div v-show="!showFiltersCollapsed" class="filters-list">
                  <span
                    v-for="(sts, key) in requestFilters[0].value"
                    :key="'status-filter-' + sts + '-' + key"
                    class="filter-selection">
                    {{formatLabelFirstLetter('ordersStatus.' + sts)}}<a title="Remove filter" href="#" @click.prevent="removeStatusFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                  </span>
                  <span
                    v-for="(locId, key) in locationFilter"
                    :key="'location-filter-' + locId + '-' + key"
                    class="filter-selection">
                    {{getLocationName(locId)}} <a title="Remove filter" href="#" @click.prevent="removeLocationFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                  </span>
                  <template v-if="orderFilters.pickupDatetime && orderFilters.pickupDatetime.length === 2">
                    <span class="filter-selection">Pickup: {{formatDateRange(orderFilters.pickupDatetime)}} <a title="Remove filter" href="#" @click.prevent="removePickupDatetimeFilter()"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                  </template>
                  <template v-if="orderFilters.placedDatetime && orderFilters.placedDatetime.length === 2">
                    <span class="filter-selection">Placed: {{formatDateRange(orderFilters.placedDatetime)}} <a title="Remove filter" href="#" @click.prevent="removePlacedDatetimeFilter()"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                  </template>
                  <template v-if="orderFilters.orderId">
                    <span class="filter-selection">Order ID: {{orderFilters.orderId}} <a title="Remove filter" href="#" @click.prevent="removeOrderIdFilter()"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                  </template>
                  <template v-if="orderFilters.orderNumber">
                    <span class="filter-selection">Order #: {{orderFilters.orderNumber}} <a title="Remove filter" href="#" @click.prevent="removeOrderNumberFilter()"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                  </template>
                  <template v-if="orderFilters.orderTotalMin || orderFilters.orderTotalMax">
                    <span class="filter-selection">Total: {{orderFilters.orderTotalMin || '0'}} - {{orderFilters.orderTotalMax || '∞'}} <a title="Remove filter" href="#" @click.prevent="removeOrderTotalFilter()"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                  </template>
                  <template v-if="orderFilters.operator && orderFilters.operator.length > 0">
                    <span
                      v-for="(opId, key) in orderFilters.operator"
                      :key="'operator-filter-' + opId + '-' + key"
                      class="filter-selection">
                      Operator: {{getOperatorName(opId)}} <a title="Remove filter" href="#" @click.prevent="removeOperatorFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                    </span>
                  </template>
                  <template v-if="orderFilters.paymentType && orderFilters.paymentType.length > 0">
                    <span
                      v-for="(pt, key) in orderFilters.paymentType"
                      :key="'payment-type-filter-' + pt + '-' + key"
                      class="filter-selection">
                      Payment: {{formatLabelFirstLetter('paymentTypes.' + pt)}} <a title="Remove filter" href="#" @click.prevent="removePaymentTypeFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                    </span>
                  </template>
                  <template v-if="orderFilters.deliveryType && orderFilters.deliveryType.length > 0">
                    <span
                      v-for="(dt, key) in orderFilters.deliveryType"
                      :key="'delivery-type-filter-' + dt + '-' + key"
                      class="filter-selection">
                      {{$t('settingCompany.deliveryType')}}: {{formatLabelFirstLetter('deliveryTypes.' + dt)}} <a title="Remove filter" href="#" @click.prevent="removeDeliveryTypeFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                    </span>
                  </template>
                  <template v-if="orderFilters.source && orderFilters.source.length > 0">
                    <span
                      v-for="(src, key) in orderFilters.source"
                      :key="'source-filter-' + src + '-' + key"
                      class="filter-selection">
                      Source: {{formatLabelFirstLetter('ordersSource.' + src)}} <a title="Remove filter" href="#" @click.prevent="removeSourceFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                    </span>
                  </template>
                </div>
                <a href="#" @click.prevent="resetFilters()" class="reset-filters-link">{{$t('orders.resetFilters')}}</a>
              </template>
              <template v-else>
                {{$t('orders.noFiltersApplied')}}
              </template>
            </div>
            <div class="statuses order-buttons">
              <div class="status new" :class="{ selected: requestFilters[0].value.includes('NEW') }" @click="toggleStatus('NEW')">
                <span>{{ $t('ordersStatus.NEW') }}</span>
              </div>
              <div class="status processing" :class="{ selected: requestFilters[0].value.includes('PROCESSING') }" @click="toggleStatus('PROCESSING')">
                <span>{{ $t('ordersStatus.PROCESSING') }}</span>
              </div>
              <div class="status prepared" :class="{ selected: requestFilters[0].value.includes('PREPARED') }" @click="toggleStatus('PREPARED')">
                <span>{{ $t('ordersStatus.PREPARED') }}</span>
              </div>
              <div class="status in-transport" :class="{ selected: requestFilters[0].value.includes('TRANSPORT') }" @click="toggleStatus('TRANSPORT')">
                <span>{{ $t('ordersStatus.TRANSPORT') }}</span>
              </div>
            </div>
            <div class="drivers">
              <div class="driver">
                <template>
                  <div v-if="groupsDispatch.length" class="groups-container">
                    <div v-for="group in groupsDispatch" :key="group.id" class="group-box">
                      <div class="order">
                        <div class="head">
                          <div class="orderId">
                            <span>Group ID: {{ group.id }}</span>
                          </div>
                          <div class="statusHeader">
                            <span class="bached">
                              Batched
                            </span>
                          </div>
                        </div>
                        <div class="ord">
                          <p
                            v-for="order in group.orders"
                            :key="order.id"
                            @click="goToOrder(order.id)"
                            :class="{
                              'status-prepared': order.status === 'PREPARED',
                              'status-processing': order.status === 'PROCESSING',
                              'status-new': order.status === 'NEW'
                            }"
                          >
                            Order #{{ order.number }}
                          </p>
                          <div class="footer">
                            <div class="buttons">
                              <div class="goToDriver">
                                <button class="btn btn-info" @click.stop="addGroupOrderDriverModal(group.id)">
                                  ASSIGN DRIVER
                                </button>
                                <!-- <button class="btn btn-info assigned-driver" @click.stop="showDriverModal(order.id)">
                                  {{ order.driver.firstname }} {{ order.driver.lastname }}
                                </button> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                  <!-- tag="order" -->
                  <template v-if="orders.length">
                    <div v-for="order in orders" :key="order.id" :data-order_id="order.id">
                      <template>
                        <div>
                          <div :class="[
                              'order',
                              order.id === selectedOrderId ? 'selected' : ''
                              ]" v-if="order" @click.stop="highlightOrderOnMap(order.id)"
                              >
                            <div class="head">
                              <div class="orderId" @click="goToOrder(order.id)">
                                <span>{{ $t('orders.orderNoArticulate') }} #{{formatOrderNr(order.number)}}</span>
                              </div>
                              <div class="statusHeader">
                                <span :class="getStatusClass(order.status, order.driver)">
                                  {{ getStatusText(order.status, order.driver) }}
                                </span>
                              </div>
                              <div class="date">
                                <img
                                  :src="order.id === selectedOrderId
                                  ? '/static/img/icon-date-white.png'
                                  : '/static/img/icon-calendar.png'"
                                  alt="Date Icon"
                                />
                                <span>{{ order.pickup_datetime }}</span>
                              </div>
                            </div>
                            <div class="ord">
                              <div class="ord_mid">
                                <div class="client">
                                  <span><b>{{order.delivery_details_firstname}}</b></span>
                                  <span class="phone">{{order.delivery_details_phone}}</span>
                                  <div class="address">
                                    <!-- <div class="zones" v-if="order && order.shipping_details">
                                      <span>{{order.shipping_details.name}}</span>
                                    </div> -->
                                    <div class="address_shipping" v-if="order && order.address_shipping">
                                      <span>
                                        <img src="/static/img/icon-location.png">
                                        <!-- {{order.address_shipping.state}} {{order.address_shipping.city}}, -->
                                        {{order.address_shipping.street}} {{order.address_shipping.number}}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="address">
                                  <!-- <div class="zones" v-if="order && order.shipping_details">
                                    <span>{{order.shipping_details.name}}</span>
                                  </div> -->
                                  <!-- <div class="address_shipping" v-if="order && order.address_shipping">
                                    <span>
                                      <img src="/static/img/icon-location.png">
                                      {{order.address_shipping.street}} {{order.address_shipping.number}}
                                    </span>
                                  </div> -->
                                  <div class="production_details" v-if="order.production_details && order.production_details.location">
                                    <span>
                                      <b>{{$t('orders.ordLocation')}}:</b>
                                      {{order.production_details.location.name}}
                                      <i class="fa fa-pencil"
                                        @click="showLocationModal(order.id)"
                                        v-if="order && (order.status === 'PROCESSING' || order.status === 'NEW')">
                                      </i>
                                    </span>
                                    <span v-if="order && order.shipping_details" class="zone">
                                      <b>{{$t('dispath.zone')}}:</b>
                                      {{order.shipping_details.name}}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="footer">
                                <div class="total">
                                  <span>{{order.totals_grandtotal}} {{order.currency}} ({{order.payment_type}})</span>
                                </div>
                                <div class="buttons">
                                  <!-- <div class="map">
                                    <button class="btn btn-info" v-if="order.status == 'TRANSPORT'" @click="getCoords(order.id)">Vezi Traseu</button>
                                  </div> -->
                                  <div class="updateStatus">
                                    <button
                                      class="btn btn-info btn-processing"
                                      v-if="order && order.status == 'NEW'"
                                      @click.stop="updateStatus(order.id, 'PROCESSING')"
                                      >
                                      {{ $t('ordersStatus.PROCESSING') }}
                                    </button>
                                    <button
                                      class="btn btn-info btn-prepared"
                                      v-if="order && order.status == 'PROCESSING'"
                                      @click.stop="updateStatus(order.id, 'PREPARED')"
                                      >
                                      {{ $t('ordersStatus.PREPARED') }}
                                    </button>
                                  </div>
                                  <div class="goToDriver" v-if="order && order.status == 'PREPARED'">
                                    <button v-if="!order.driver" class="btn btn-info" @click.stop="showDriverModal(order.id)">
                                      ASSIGN DRIVER
                                    </button>
                                    <button v-else class="btn btn-info assigned-driver" @click.stop="showDriverModal(order.id)">
                                      {{ order.driver.firstname }} {{ order.driver.lastname }}
                                    </button>
                                  </div>
                                  <div class="goToDriver" v-if="order && order.driver && order.status == 'TRANSPORT'">
                                    <button class="btn btn-info assigned-driver" @click.stop="showDriverOnMap(order.driver)">
                                      {{ order.driver.firstname }} {{ order.driver.lastname }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </template>
                  <template v-else>
                      <div class="no-orders">
                          <img src="/static/img/no-orders.png">
                      </div>
                  </template>
              </div>
            </div>
          </div>
          <div class="col-maps">
            <!--General Top Bar -->
            <!-- <general-top-bar :title="$t('pages.dispatch')"></general-top-bar> -->
            <!--End General Top Bar -->
            <div class="maps-buttons">
              <button @click="resetMap" class="btn add mar-rt-10">
                {{ $t('dispath.reset_map') }}
              </button>
              <div class="checkbox">
                <input
                  type="checkbox"
                  :value="'delivery'"
                  v-model="selectedButtons"
                  @change="updateSelection('delivery')">
                <label class="checkbox-label">{{ $t('dispath.drivers') }}</label>
              </div>
              <div class="checkbox">
                <input
                  type="checkbox"
                  :value="'orders'"
                  v-model="selectedButtons"
                  @change="updateSelection('orders')">
                <label class="checkbox-label">{{ $t('dispath.orders') }}</label>
              </div>
              <div class="checkbox">
                <input
                  type="checkbox"
                  :value="'zones'"
                  v-model="selectedButtons"
                  @change="updateSelection('zones')">
                <label class="checkbox-label">{{ $t('dispath.zone') }}</label>
              </div>
            </div>
            <div class="mapsDispatch">
              <template>
                <div>
                  <div class="card-map">
                    <div class="card-header">
                      <!-- <h4 class="card-title">Full Screen Map</h4> -->
                    </div>
                    <div id="map" class="full-screen-map"></div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Filters and Sort Modal (same as Orders.vue) -->
    <vmodal name="dispatchFiltersModal" height="auto" width="1200" :adaptive="true" :scrollable="true" class="filtersAndSortModal dispatch-filters-modal">
      <div class="card">
        <div class="card-content">
          <div class="modal-header slim-header">
            <h4>{{$t('orders.filtersAndSort')}}</h4>
          </div>
          <div class="modal-body slim-body">
            <div class="filters-grid">
              <div class="modal-column-left">
                <h6 class="section-title">{{$t('orders.filters')}}</h6>

                <div class="filter-section">
                  <h6>{{$t('orders.status')}}</h6>
                  <div class="button-group-wrap status-filter-buttons">
                    <button
                      v-for="key in filteredStatuses"
                      :key="key"
                      :class="'btn btn-status-filter ' + (modalRequestFilters[0].value.includes(key) ? 'btn-' + orderStatusClass(key) + ' current ' + key : 'btn-default')"
                      @click="toggleModalStatusFilter(key)">
                      {{formatLabelFirstLetter('ordersStatus.' + key)}}
                    </button>
                  </div>
                </div>

                <div class="filter-section">
                  <h6>{{$t('settingCompany.deliveryType')}}</h6>
                  <div class="button-group-wrap status-filter-buttons delivery-type-buttons">
                    <button
                      v-for="dt in deliveryTypeOptions"
                      :key="dt"
                      :class="'btn btn-status-filter ' + (modalOrderFilters.deliveryType && modalOrderFilters.deliveryType.includes(dt) ? 'btn-primary current ' + dt : 'btn-default')"
                      @click="toggleModalDeliveryTypeFilter(dt)">
                      {{formatLabelFirstLetter('deliveryTypes.' + dt)}}
                    </button>
                  </div>
                </div>

                <div class="filter-section">
                  <h6>{{$t('orders.source')}}</h6>
                  <div class="button-group-wrap status-filter-buttons source-filter-buttons">
                    <button
                      v-for="src in sourceOptions"
                      :key="src"
                      :class="'btn btn-status-filter ' + (modalOrderFilters.source && modalOrderFilters.source.includes(src) ? 'btn-primary current ' + src : 'btn-default')"
                      @click="toggleModalSourceFilter(src)">
                      {{formatLabelFirstLetter('ordersSource.' + src)}}
                    </button>
                  </div>
                </div>

                <div class="filter-section">
                  <h6>{{$t('orders.payment')}}</h6>
                  <div class="button-group-wrap status-filter-buttons payment-type-buttons">
                    <button
                      v-for="pt in paymentTypeOptions"
                      :key="pt"
                      :class="'btn btn-status-filter ' + (modalOrderFilters.paymentType && modalOrderFilters.paymentType.includes(pt) ? 'btn-primary current ' + pt : 'btn-default')"
                      @click="toggleModalPaymentTypeFilter(pt)">
                      {{formatLabelFirstLetter('paymentTypes.' + pt)}}
                    </button>
                  </div>
                </div>
              </div>

              <div class="modal-column-right">
                <div class="filter-section">
                  <h6>{{$t('orders.pickupDatetime')}}</h6>
                  <el-date-picker
                    type="datetimerange"
                    v-model="modalOrderFilters.pickupDatetime"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$t('orders.selectDateRange')"
                    @change="adjustDatetimeRange('pickupDatetime')"
                    style="width: 100%;">
                  </el-date-picker>
                </div>

                <div class="filter-section">
                  <h6>{{$t('orders.placedDatetime')}}</h6>
                  <el-date-picker
                    type="datetimerange"
                    v-model="modalOrderFilters.placedDatetime"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$t('orders.selectDateRange')"
                    @change="adjustDatetimeRange('placedDatetime')"
                    style="width: 100%;">
                  </el-date-picker>
                </div>

                <div class="filter-section">
                  <h6>{{$t('orders.location')}}</h6>
                  <el-select
                    v-model="modalLocationFilter"
                    multiple
                    clearable
                    filterable
                    collapse-tags
                    class="w-100"
                    style="width: 100%;"
                    :placeholder="$t('orders.location')">
                    <el-option
                      v-for="loc in locations"
                      :key="'modal-location-' + loc.id"
                      :label="loc.name"
                      :value="getLocationFilterValue(loc)">
                    </el-option>
                  </el-select>
                </div>

                <div class="filter-section">
                  <h6>{{$t('orders.orderId')}}</h6>
                  <el-input
                    v-model="modalOrderFilters.orderId"
                    :placeholder="$t('orders.enterOrderId')">
                  </el-input>
                </div>

                <div class="filter-section">
                  <h6>{{$t('orders.orderNumber')}}</h6>
                  <el-input
                    v-model="modalOrderFilters.orderNumber"
                    :placeholder="$t('orders.enterOrderNumber')">
                  </el-input>
                </div>

                <div class="filter-section">
                  <h6>{{$t('orders.operator')}}</h6>
                  <el-select
                    v-model="modalOrderFilters.operator"
                    multiple
                    clearable
                    filterable
                    collapse-tags
                    class="w-100"
                    style="width: 100%;"
                    :placeholder="$t('reports.operator')">
                    <el-option
                      v-for="op in operatorOptions"
                      :key="'op-' + op.id"
                      :label="op.label"
                      :value="op.id">
                    </el-option>
                  </el-select>
                </div>

                <div class="filter-section">
                  <h6>{{$t('orders.orderTotal')}}</h6>
                  <div class="range-row">
                    <el-input-number
                      v-model="modalOrderFilters.orderTotalMin"
                      :placeholder="$t('orders.min')"
                      :precision="2"
                      :controls="false"
                      style="flex: 1; line-height: 44px;">
                    </el-input-number>
                    <span>-</span>
                    <el-input-number
                      v-model="modalOrderFilters.orderTotalMax"
                      :placeholder="$t('orders.max')"
                      :precision="2"
                      :controls="false"
                      style="flex: 1; line-height: 44px;">
                    </el-input-number>
                  </div>
                </div>

                <div class="filter-section">
                  <h6>{{$t('general.sortOrder')}}</h6>
                  <el-radio-group v-model="modalSortOrder">
                    <el-radio
                      v-for="sort in sortOptions"
                      :key="'sort-' + sort.id"
                      :label="sort.id"
                      style="display: block; margin-bottom: 10px;">
                      {{$t('general.sort' + sort.name)}}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>

            <div class="modal-footer slim-footer">
              <el-button type="default" size="small" @click="resetModalFilters">{{$t('general.reset')}}</el-button>
              <el-button type="primary" size="small" @click="applyFilters">{{$t('general.apply')}}</el-button>
            </div>
          </div>
        </div>
      </div>
    </vmodal>
    <!-- Modalul pentru afișarea șoferilor -->
    <vmodal name="driverModal" height="auto" width="900" class="modalDriver">
      <div class="card height-95-vh">
        <div class="card-content">
          <div class="modal-header">
            <p>{{$t('settingCompany.assignOrderToDriver')}}</p>
            <hr class="sm">
            <button class="close" @click="hideDriverModal">X</button>
          </div>
          <div class="modal-body">
            <data-tables
              v-loading="loading"
              :data="driverTableData"
              ref="driverList"
              :table-props="{'border': false, 'height': 'auto'}"
              style="width: 100%">
              <el-table-column
                :min-width="200"
                prop="name"
                label="Name">
              </el-table-column>
              <el-table-column
                :min-width="200"
                prop="orders"
                label="Orders">
              </el-table-column>
              <el-table-column
                :min-width="200"
                prop="distance"
                label="Distance">
              </el-table-column>
              <el-table-column
                :min-width="150"
                label="Action">
                <template slot-scope="scope">
                  <button class="btn"
                    :class="scope.row.hasAssignedOrder ? 'btn-info' : 'btn-info'"
                    :disabled="!scope.row.canAssign"
                    @click="scope.row.hasAssignedOrder ? unassignDriver(scope.row) : assignDriver(scope.row)">
                    {{ scope.row.hasAssignedOrder ? 'Unassign Driver' : 'Assign Driver' }}
                  </button>
                </template>
              </el-table-column>
            </data-tables>
          </div>
        </div>
      </div>
    </vmodal>
    <!-- Modalul pentru afișarea orderPos -->
    <vmodal name="ordersPosModal" height="auto" width="1900" class="ordersPosModal">
      <div class="card">
        <div class="card-content">
          <div class="modal-header">
            <button class="close" @click="hideOrdersPosModal">X</button>
          </div>
          <div class="modal-body">
            <!-- Embed OrdersPos component inside the modal -->
            <OrdersPos />
          </div>
        </div>
      </div>
    </vmodal>
    <!-- Modalul pentru afișarea locatiilor -->
    <vmodal name="changeLocation" height="auto" width="800" class="changeLocation">
      <div class="card">
        <div class="card-content">
          <div class="modal-header">
            <button class="close" @click="hideLocationModal">X</button>
          </div>
          <div class="modal-body">
            <div
              v-for="loc in locations"
              :key="loc.true_id"
              class="location-item"
              @click="changeOrderLocation(loc.true_id)"
            >
            {{ loc.name }}
            </div>
          </div>
        </div>
      </div>
    </vmodal>
    <!-- Modalul pentru afișarea groupOrders -->
    <vmodal name="ordersGroupModal" height="auto" width="1400" class="ordersGroupModal">
      <div class="card">
        <div class="card-content">
          <div class="modal-header">
            <button class="close" @click="hideAddOrdersGroupModal">X</button>
          </div>
          <div class="modal-body">
            <div class="row grouped">
              <div class="col-order ungrouped">
                <div class="ungrouped-title">
                  <p>{{$t('dispath.unassigned')}}</p>
                </div>
                <template v-if="groupingOrders.length">
                  <div class="overflow-box">
                    <div class="box-ungrouped">
                      <draggable v-model="groupingOrders"
                        @end="onDropOrder"
                        group="ungroupedOrders"
                        class="order-list"
                        name="gr1"
                        style="display: contents;">
                        <transition-group class="transition box-ungrouped" :data-group_id="0" name="tr1">
                          <div v-for="order in groupingOrders" :key="order.id" class="order-card" :data-order-id="order.id">
                            <div class="order-top">
                              <div class="örderId">
                                <p>Order #{{ order.number }}</p>
                              </div>
                              <div class="orderDate">
                                <img
                                  src="/static/img/icon-calendar.png"
                                  alt="Date Icon"
                                />
                                <span>{{ order.pickup_datetime.split(' ')[1] }}</span>
                              </div>
                            </div>
                            <div class="ord-client">
                              <div class="address">
                                <div class="address_shipping" v-if="order && order.address_shipping">
                                  <span
                                    class="address-tooltip"
                                    v-if="order && order.address_shipping"
                                    :title="`${order.address_shipping.street} ${order.address_shipping.number}`">
                                    <img src="/static/img/icon-location.png" />
                                    <span class="ellipsis-text">{{ order.address_shipping.street }} {{ order.address_shipping.number }}</span>
                                  </span>
                                </div>
                                <div class="production_details" v-if="order.production_details && order.production_details.location">
                                  <span v-if="order && order.shipping_details" class="zone">
                                    <b>{{$t('dispath.zone')}}:</b>
                                    {{order.shipping_details.name}}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </transition-group>
                      </draggable>
                    </div>
                  </div>
                </template>
              </div>
              <div class="col-order separator">
                <hr />
              </div>
              <div class="col-order grouped">
                <div class="ungrouped-title">
                  <p>{{$t('dispath.batched')}}</p>
                </div>
                <div class="overflow-box">
                  <template class="posibleGroup">
                    <div v-if="groupingOrdersByZone.length" class="grouped-orders posibleGroup">
                      <!-- Loop through each group by delivery_ranges_id -->
                      <div v-for="group in groupingOrdersByZone" :key="group.delivery_ranges_id" class="group-card">
                        <!-- Card Header showing the delivery_ranges_id -->
                        <div class="group-header">
                          <div class="sugestion-id">
                            <p>{{$t('orders.zone')}}: {{ group.delivery_range.name }}</p>
                          </div>
                          <div class="sugestion-flag">
                            <p>{{$t('dispath.sugestion')}}!</p>
                          </div>
                          <div class="saveGrouped">
                          <button type="submit" @click="createOrderGroup(group)" class="btn btn-icon btn-success btn mar-rt-10 save" :title="$t('general.save')">
                              <img src="/static/img/icons/save.png">
                              {{$t('general.save')}}
                          </button>
                        </div>
                        </div>
                        <div class="sugestion-box">
                          <!-- Loop through each order inside the group -->
                          <div v-for="order in group.orders" :key="order.id" class="order-card">
                            <div class="order-top">
                              <div class="örderId">
                                <p>Order #{{ order.number }}</p>
                              </div>
                              <div class="orderDate">
                                <img src="/static/img/icon-calendar.png" alt="Date Icon" />
                                <span>{{ order.pickup_datetime.split(' ')[1] }}</span>
                              </div>
                              <!-- Close Button (X) in the top-right corner -->
                              <button class="close-btn" @click="removeOrderGroupPosibile(group, order.id)">×</button>
                            </div>
                            <div class="ord-client">
                              <div class="address">
                                <div class="address_shipping" v-if="order && order.address_shipping">
                                  <span
                                    class="address-tooltip"
                                    v-if="order && order.address_shipping"
                                    :title="`${order.address_shipping.street} ${order.address_shipping.number}`">
                                    <img src="/static/img/icon-location.png" />
                                    <span class="ellipsis-text">{{ order.address_shipping.street }} {{ order.address_shipping.number }}</span>
                                  </span>
                                </div>
                                <div class="production_details" v-if="order.production_details && order.production_details.location">
                                  <span v-if="order && order.shipping_details" class="zone">
                                    <b>{{$t('orders.zone')}}:</b>
                                    {{ order.shipping_details.name }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template
                    class="availableGroup">
                    <div v-if="groups.length" class="grouped-orders">
                      <draggable v-model="groups" :disabled="true" group="groups">
                        <!-- Loop through each group by delivery_ranges_id -->
                        <div v-for="group in groups" :key="group.id" class="group-card" :class="{ 'has-suggestions': group.orders_suggestions && group.orders_suggestions.length > 0 }" :data-group-id="group.id">
                          <!-- Card Header showing the delivery_ranges_id -->
                          <div class="group-header">
                            <p>ID: {{ group.id }}</p>
                            <div class="sugestion-flag" v-if="group.orders_suggestions && group.orders_suggestions.length">
                              <p>{{$t('dispath.sugestion')}}!</p>
                            </div>
                          </div>
                          <div class="box-inline-groups">
                            <div class="orders-container">
                              <!-- Display suggested orders for this group -->
                              <div class="formated-group orders-suggestions" v-if="group.orders_suggestions && group.orders_suggestions.length">
                                <transition-group class="transition formated-group" :data-group_id="group.id" name="tr1">
                                  <div v-for="suggestion in group.orders_suggestions" :key="suggestion.id" class="order-card suggested-order" :data-order-id="suggestion.id">
                                    <div class="order-top">
                                      <div class="örderId">
                                        <p>Order #{{ suggestion.number }}</p>
                                      </div>
                                      <div class="orderDate">
                                        <img src="/static/img/icon-calendar.png" alt="Date Icon" />
                                        <span>{{ suggestion.pickup_datetime.split(' ')[1] }}</span>
                                      </div>
                                      <!-- Close Button (X) in the top-right corner -->
                                      <button class="plus-btn" @click="addOrderGroupPosibile(group, suggestion.id)">+</button>
                                    </div>
                                    <div class="ord-client">
                                      <div class="address">
                                        <span v-if="suggestion.address_shipping" :title="`${suggestion.address_shipping.street} ${suggestion.address_shipping.number}`">
                                          <img src="/static/img/icon-location.png" />
                                          <span class="ellipsis-text">{{ suggestion.address_shipping.street }} {{ suggestion.address_shipping.number }}</span>
                                        </span>
                                        <div v-if="suggestion.shipping_details" class="zone">
                                          <b>{{$t('dispath.zone')}}:</b> {{ suggestion.shipping_details.name }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </transition-group>
                              </div>
                              <div class="formated-group">
                                <draggable
                                v-model="group.orders"
                                class="formated-group"
                                :name="'gr'+group.id"
                                :group="{ name: 'groupedOrders', pull: 'clone', put: true }">
                                  <transition-group class="transition formated-group" :data-group_id="group.id" name="tr1">
                                    <!-- Loop through each order inside the group -->
                                    <div v-for="order in group.orders" :key="order.id" class="order-card" :data-order-id="order.id">
                                      <div class="order-top">
                                        <div class="örderId">
                                          <p>Order #{{ order.number }}</p>
                                        </div>
                                        <div class="orderDate">
                                          <img src="/static/img/icon-calendar.png" alt="Date Icon" />
                                          <span>{{ order.pickup_datetime.split(' ')[1] }}</span>
                                        </div>
                                        <!-- Close Button (X) in the top-right corner -->
                                        <button class="close-btn" @click="removeOrderGroup(group, order.id)">×</button>
                                      </div>
                                      <div class="ord-client">
                                        <div class="address">
                                          <span
                                            class="address-tooltip"
                                            v-if="order && order.address_shipping"
                                            :title="`${order.address_shipping.street} ${order.address_shipping.number}`">
                                            <img src="/static/img/icon-location.png" />
                                            <span class="ellipsis-text">{{ order.address_shipping.street }} {{ order.address_shipping.number }}</span>
                                          </span>
                                          <div class="production_details" v-if="order.production_details && order.production_details.location">
                                            <span v-if="order && order.shipping_details" class="zone">
                                              <b>{{$t('dispath.zone')}}:</b>
                                              {{ order.shipping_details.name }}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </transition-group>
                                </draggable>
                              </div>
                            </div>
                          </div>
                        </div>
                      </draggable>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vmodal>
     <!-- Modalul pentru afișarea orderView -->
     <vmodal name="ordersViewModal" height="auto" width="1900" class="ordersViewModal">
      <div class="card">
        <div class="card-content">
          <div class="modal-header">
            <button class="close" @click="hideOrdersViewModal">X</button>
          </div>
          <div class="modal-body">
            <!-- Embed OrdersPos component inside the modal -->
            <iframe
              v-if="orderId"
              :src="`/orders/view/${orderId}`"
              width="100%"
              height="600"
              frameborder="0"
            ></iframe>
          </div>
        </div>
      </div>
    </vmodal>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Table, TableColumn, Row, Select, Option, Checkbox, CheckboxGroup, Dropdown, DropdownMenu, DropdownItem, DatePicker, Button, InputNumber, Radio, RadioGroup} from 'element-ui'
  import draggable from 'vuedraggable'
  import DataTables from 'vue-data-tables'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import DispatchOrders from './DispatchOrders.vue'
  import DispatchDrivers from './DispatchDrivers.vue'
  import OrdersPos from '../OrdersPos/OrdersPos.vue'
  import vmodal from 'vue-js-modal'
  import swal from 'sweetalert2'
  import GoogleMapsLoader from 'google-maps'
  import OrderView from '../Orders/OrderView.vue'

  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DataTables)
  Vue.use(Row)
  Vue.use(Checkbox)
  Vue.use(CheckboxGroup)
  Vue.use(Dropdown)
  Vue.use(DropdownMenu)
  Vue.use(DropdownItem)
  Vue.use(Button)
  Vue.use(InputNumber)
  Vue.use(Radio)
  Vue.use(RadioGroup)
  Vue.use(vmodal, { componentName: 'vmodal' })

  const DEFAULT_DISPATCH_STATUSES = ['PREPARED', 'TRANSPORT']
  const DEFAULT_DISPATCH_DELIVERY_TYPES = ['DELIVERY']

  export default {
    name: 'DispatchView',
    components: {
      [DatePicker.name]: DatePicker,
      draggable,
      PPagination,
      DispatchOrders,
      DispatchDrivers,
      // GeneralTopBar,
      OrdersPos,
      OrderView,
      PSwitch
    },
    computed: {
      hasActiveFilters () {
        const hasStatusFilters = this.requestFilters[0].value.length > 0
        const hasLocationFilters = this.locationFilter.length > 0
        const hasPickupDatetime = this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2
        const hasPlacedDatetime = this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2
        const hasOrderId = this.orderFilters.orderId && String(this.orderFilters.orderId).trim() !== ''
        const hasOrderNumber = this.orderFilters.orderNumber && this.orderFilters.orderNumber.trim() !== ''
        const hasOrderTotal = this.normalizeOrderTotal(this.orderFilters.orderTotalMin) !== null || this.normalizeOrderTotal(this.orderFilters.orderTotalMax) !== null
        const hasOperator = this.orderFilters.operator && this.orderFilters.operator.length > 0
        const hasPaymentType = this.orderFilters.paymentType && this.orderFilters.paymentType.length > 0
        const hasDeliveryType = this.orderFilters.deliveryType && this.orderFilters.deliveryType.length > 0
        const hasSource = this.orderFilters.source && this.orderFilters.source.length > 0

        return hasStatusFilters || hasLocationFilters || hasPickupDatetime || hasPlacedDatetime ||
               hasOrderId || hasOrderNumber || hasOrderTotal || hasOperator || hasPaymentType || hasDeliveryType || hasSource
      },
      filteredStatuses () {
        return Object.keys(this.statuses).filter(key => key !== 'DRAFT')
      }
    },
    props: {
      order: {}
    },
    created: function () {
      this.loadDispatchFilters()
      this.getPosUsers()
      this.getLocationAndZones().then(() => {
        this.getData()
      })
    },
    beforeDestroy () {
    },
    data () {
      return {
        use_auto_dispatch2: null,
        use_auto_dispatch: null,
        userInteractedMap: false,
        selectedOrderId: null,
        orderId: null,
        selectedOrderAssigned: false,
        working_drivers: [],
        driverTableData: [],
        orders: [],
        groupingOrders: [],
        groupingOrdersByZone: [],
        groups: [],
        groupsDispatch: [],
        getDataTimeout: null,
        loading: false,
        orderUrl: '',
        isModalFilterChange: false,
        modalOrderFilters: {
          pickupDatetime: null,
          placedDatetime: null,
          orderId: '',
          orderNumber: '',
          orderTotalMin: null,
          orderTotalMax: null,
          operator: [],
          paymentType: [],
          deliveryType: DEFAULT_DISPATCH_DELIVERY_TYPES.slice(),
          source: []
        },
        modalLocationFilter: [],
        modalSortOrder: 1,
        modalRequestFilters: [{value: DEFAULT_DISPATCH_STATUSES.slice()}],
        requestFilters: [{value: DEFAULT_DISPATCH_STATUSES.slice()}],
        locationFilter: [],
        sortOrder: 1,
        showFiltersCollapsed: false,
        operatorOptions: [],
        sourceOptions: [1, 2, 3, 4, 5, 6, 7, 8],
        paymentTypeOptions: ['CASH', 'CARD', 'POS', 'CARD_POS', 'CASH_MACHINE', 'POS_KIOSK', 'ONLINE', 'SPLIT', 'ROOM', 'FOLIO', 'EVENT', 'MANCARE_PERSONAL', 'PROTOCOL', 'VIRAMENT', 'GLOVO_CARD', 'GLOVO_CASH', 'BOLT_CASH', 'BOLT_CARD', 'WOLT_CASH', 'WOLT_CARD', 'null'],
        deliveryTypeOptions: ['PICK_UP', 'DELIVERY', 'EAT_LOCATION', 'MEET_HALF'],
        orderFilters: {
          pickupDatetime: null,
          placedDatetime: null,
          orderId: '',
          orderNumber: '',
          orderTotalMin: null,
          orderTotalMax: null,
          operator: [],
          paymentType: [],
          deliveryType: DEFAULT_DISPATCH_DELIVERY_TYPES.slice(),
          source: []
        },
        sortOptions: [
          { id: 1, name: 'CreatedDescending' },
          { id: 2, name: 'CreatedAscending' },
          { id: 3, name: 'PickupDescending' },
          { id: 4, name: 'PickupAscending' }
        ],
        resetFiltersObj: [{value: DEFAULT_DISPATCH_STATUSES.slice()}],
        statuses: this.$session.get('defaultData')['order_statuses']['ALL_DELIVERY_TYPES'],
        map: null,
        markers: [],
        shapes: [],
        locations: [],
        selectedButtons: []
      }
    },
    mounted () {
      const locationsDetails = this.$session.get('selectedCompanyData').locations_details
      let apiKey = null

      for (let location of locationsDetails) {
        if (location.google_maps_api_key) {
          apiKey = location.google_maps_api_key
          break
        }
      }
      if (apiKey) {
        GoogleMapsLoader.KEY = apiKey
        GoogleMapsLoader.load((google) => {
          this.initMap(google)
        })
      } else {
        console.error('No Google Maps API key found in locations details.')
      }
    },
    watch: {
      map (newMap) {
        if (newMap) {
          newMap.addListener('dragstart', () => { this.userInteractedMap = true })
          newMap.addListener('zoom_changed', () => { this.userInteractedMap = true })
          newMap.addListener('center_changed', () => { this.userInteractedMap = true })
        }
      }
    },
    methods: {
      buildDispatchFilterParams () {
        const data = {}

        // Always send statuses (including defaults) so the request matches the UI
        data.statuses = (this.requestFilters[0].value && this.requestFilters[0].value.length)
          ? this.requestFilters[0].value.join(',')
          : DEFAULT_DISPATCH_STATUSES.join(',')

        if (this.locationFilter.length) {
          const normalizedIds = this.locationFilter.map(id => parseInt(id, 10)).filter(id => !isNaN(id))
          data.locations = normalizedIds.join(',')
        }

        const sortOrderId = this.sortOrder || 1
        const sortOption = this.sortOptions.find(sort => sort.id === parseInt(sortOrderId))
        // Always send sort (default CreatedDescending)
        data.sort_order = sortOption ? sortOption.name : 'CreatedDescending'

        if (this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2) {
          data.pickup_datetime_from = this.orderFilters.pickupDatetime[0]
          data.pickup_datetime_to = this.adjustEndTime(this.orderFilters.pickupDatetime[1])
        }
        if (this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2) {
          data.created_at_from = this.orderFilters.placedDatetime[0]
          data.created_at_to = this.adjustEndTime(this.orderFilters.placedDatetime[1])
        }
        if (this.orderFilters.orderId && String(this.orderFilters.orderId).trim() !== '') {
          data.id = String(this.orderFilters.orderId).trim()
        }
        if (this.orderFilters.orderNumber && this.orderFilters.orderNumber.trim() !== '') {
          data.order_number = this.orderFilters.orderNumber.trim()
        }
        if (this.normalizeOrderTotal(this.orderFilters.orderTotalMin) !== null) {
          data.order_total_min = this.normalizeOrderTotal(this.orderFilters.orderTotalMin)
        }
        if (this.normalizeOrderTotal(this.orderFilters.orderTotalMax) !== null) {
          data.order_total_max = this.normalizeOrderTotal(this.orderFilters.orderTotalMax)
        }
        if (this.orderFilters.operator && this.orderFilters.operator.length > 0) {
          data.operator = this.orderFilters.operator.join(',')
        }
        if (this.orderFilters.paymentType && this.orderFilters.paymentType.length > 0) {
          data.payment_type = this.orderFilters.paymentType.join(',')
        }
        // Always send delivery_type (including default DELIVERY)
        data.delivery_type = (this.orderFilters.deliveryType && this.orderFilters.deliveryType.length)
          ? this.orderFilters.deliveryType.join(',')
          : DEFAULT_DISPATCH_DELIVERY_TYPES.join(',')
        if (this.orderFilters.source && this.orderFilters.source.length > 0) {
          data.source = this.orderFilters.source.join(',')
        }

        return data
      },
      loadDispatchFilters () {
        try {
          const savedFilters = JSON.parse(localStorage.getItem('dispatchOrderFilters'))
          if (!savedFilters) {
            return
          }
          if (savedFilters.requestFilters && savedFilters.requestFilters[0]) {
            this.requestFilters[0].value = savedFilters.requestFilters[0].value || this.requestFilters[0].value
          }
          if (Array.isArray(savedFilters.locationFilter)) {
            this.locationFilter = savedFilters.locationFilter
          }
          if (savedFilters.orderFilters) {
            this.orderFilters = {
              ...this.orderFilters,
              ...savedFilters.orderFilters
            }
          }
          if (savedFilters.sortOrder) {
            this.sortOrder = parseInt(savedFilters.sortOrder) || 1
          }
        } catch (e) {
          // ignore invalid saved filters
        }
      },
      persistDispatchFilters () {
        localStorage.setItem('dispatchOrderFilters', JSON.stringify({
          requestFilters: this.requestFilters,
          locationFilter: this.locationFilter,
          orderFilters: this.orderFilters,
          sortOrder: this.sortOrder
        }))
        localStorage.setItem('locationFilter', JSON.stringify(this.locationFilter))
      },
      refreshDispatchData () {
        this.persistDispatchFilters()
        this.updateMapMarkers(this.map)
        this.getData()
      },
      getData () {
        this.loading = true

        var dataToSend = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          ...this.buildDispatchFilterParams()
        }
        this.apiRequest('/dispatch', 'GET', dataToSend, (response) => {
          if (response.status === true) {
            this.working_drivers = response.data.working_drivers
            this.orders = response.data.orders
            this.groupsDispatch = response.data.groups
            this.loading = false
            clearTimeout(this.getDataTimeout)
            if (this.$route.name === 'Dispatch') {
              this.getDataTimeout = setTimeout(() => {
                this.getLocationAndZones()
                this.getData()
                this.updateMapMarkers(this.map)
                console.log('Auto-refreshing data...')
              }, 10000) // 10.000 milisecunde = 10 secunde
            }
          }
        })
      },
      getDriversForOrder (orderId) {
        var dataToSend = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          order_id: orderId
        }
        this.apiRequest('/get-drivers-for-order', 'GET', dataToSend, (response) => {
          if (response.status === true) {
            this.working_drivers = response.data.drivers
            this.selectedOrderAssigned = this.working_drivers.some(driver =>
              driver.orders && driver.orders.some(order => order.id === this.selectedOrderId)
            )
            this.api_drivers = this.working_drivers
            this.loadDriverData()
            this.$modal.show('driverModal')
          } else {
            swal({
              title: 'Error',
              text: 'Failed to retrieve drivers for the order.',
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            })
          }
        }, (error) => {
          console.error('Error:', error)
          swal({
            title: 'Error',
            text: 'An error occurred while retrieving drivers.',
            type: 'error',
            timer: 1500,
            showConfirmButton: false
          })
        })
      },
      changeAutoDispatch (useAutoDispatch) {
        if (useAutoDispatch !== this.use_auto_dispatch) {
          this.loading = true
          var dataToSend = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            use_auto_dispatch: useAutoDispatch
          }
          this.apiRequest('/change-auto-dispatch', 'GET', dataToSend, (response) => {
            if (response.status === true) {
              this.use_auto_dispatch = !!response.data.use_auto_dispatch
              this.loading = false
            }
          })
        }
      },
      formatOrderNr (nr) {
        return nr.toString().padStart(3, 0)
      },
      goToOrder (orderId) {
        this.$router.push('/orders/view/' + orderId)
      },
      getCoords (orderId) {
        let link = 'https://www.google.com/maps/dir/'
        var dataToSend = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          order_id: orderId
        }
        this.apiRequest('/get-order-lat-long', 'GET', dataToSend, (response) => {
          if (response.status === true) {
            link += response.data.coords
            window.open(link, '_blank')
          }
        })
      },
      toggleStatus (status) {
        const index = this.requestFilters[0].value.indexOf(status)
        if (index > -1) {
          this.requestFilters[0].value.splice(index, 1)
        } else {
          this.requestFilters[0].value.push(status)
        }
        this.refreshDispatchData()
      },
      getLocationAndZones () {
        return new Promise((resolve, reject) => {
          let dataToSend = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          this.apiRequest('/get-locations-and-zones', 'GET', dataToSend, (response) => {
            if (response.status === true) {
              this.locations = response.data.locations || []
              if (this.locationFilter.length) {
                this.locationFilter = this.normalizeLocationFilter(this.locationFilter)
              } else {
                let savedLocations = JSON.parse(localStorage.getItem('locationFilter')) || []
                this.locationFilter = this.normalizeLocationFilter(savedLocations)
              }
              this.updateMapMarkers(this.map)
              resolve()
            } else {
              reject(response.message)
            }
          })
        })
      },
      updateSelection (type) {
        if (Array.isArray(this.selectedButtons)) {
          if (type === 'delivery' || type === 'orders' || type === 'zones') {
            this.userInteractedMap = false

            this.updateMapMarkers(this.map)
          }
        } else {
          console.error('selectedButtons is not an array')
        }
      },
      initMap (google) {
        const mapEl = document.getElementById('map')
        if (!mapEl || !window.google || !window.google.maps) {
          return
        }

        // Setează locația inițială a mărcii
        var defaultLatlng = new window.google.maps.LatLng(44.4268, 26.1025)

        var mapStyles = [
          {
            featureType: 'all',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [{ color: '#d3d3d3' }]
          },
          {
            featureType: 'road',
            elementType: 'labels',
            stylers: [{ visibility: 'on' }]
          },
          {
            featureType: 'poi.business',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [{ color: '#c8e6c9' }]
          }
        ]

        // Setează opțiunile hărții
        var mapOptions = {
          zoom: 10,
          center: defaultLatlng,
          scrollwheel: false, // Dezactivează scroll-ul pe hartă
          styles: mapStyles
        }

        // Creează harta
        this.map = new window.google.maps.Map(mapEl, mapOptions)

        // Adaugă marker-e pentru locațiile selectate
        this.updateMapMarkers(this.map)

        // Atașează listener-ele după ce harta există
        this.map.addListener('dragstart', () => { this.userInteractedMap = true })
        this.map.addListener('zoom_changed', () => { this.userInteractedMap = true })
        this.map.addListener('center_changed', () => { this.userInteractedMap = true })
      },
      updateMapMarkers (map) {
        if (!map || !window.google || !window.google.maps) {
          return
        }

        // Curăță marker-ele existente (dacă este necesar)
        if (this.markers && this.markers.length) {
          this.markers.forEach(marker => marker.setMap(null))
        }
        if (this.shapes && this.shapes.length) {
          this.shapes.forEach(shape => shape.setMap(null))
        }

        this.markers = []
        this.shapes = []

        const getRandomColor = () => {
          const letters = '0123456789ABCDEF'
          let color = '#'
          for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)]
          }
          return color
        }

        this.locations.forEach(loc => {
          if (this.isLocationInFilter(loc)) {
            // Verifică dacă `lat` și `lng` sunt definite
            if (loc.lat && loc.lng) {
              let position = new window.google.maps.LatLng(loc.lat, loc.lng)
              let marker = new window.google.maps.Marker({
                position: position,
                title: loc.name,
                icon: {
                  url: '/static/img/location.png',
                  scaledSize: new window.google.maps.Size(32, 32) // Dimensiunea icon-ului
                }
              })
              marker.setMap(map)
              this.markers.push(marker)

              // Creează InfoWindow
              let infoWindowContent = `
                <div>
                    <strong>${loc.name}</strong><br>
                    Street: ${loc.street}<br>
                    Latitude: ${loc.lat}<br>
                    Longitude: ${loc.lng}
                </div>
              `
              let infoWindow = new window.google.maps.InfoWindow({
                content: infoWindowContent
              })

              // Adaugă un eveniment de click pe marker pentru a afișa InfoWindow
              marker.addListener('click', () => {
                infoWindow.open(map, marker)
              })

              // Adaugă forme dacă checkbox-ul "zones" este bifat
              if (this.selectedButtons.includes('zones')) {
                if (loc.ranges) {
                  loc.ranges.forEach(range => {
                    if (range.shape) {
                      let randomColor = getRandomColor()
                      let shapeOptions = {
                        map: map,
                        strokeColor: randomColor,
                        strokeOpacity: 0.5,
                        strokeWeight: 2,
                        fillColor: randomColor,
                        fillOpacity: 0.2
                      }

                      let shape

                      switch (range.shape.type) {
                        case 'rectangle':
                          if (range.shape.northEastLat && range.shape.northEastLng &&
                            range.shape.southWestLat && range.shape.southWestLng) {
                            shapeOptions.bounds = new window.google.maps.LatLngBounds(
                              new window.google.maps.LatLng(range.shape.southWestLat, range.shape.southWestLng),
                              new window.google.maps.LatLng(range.shape.northEastLat, range.shape.northEastLng)
                            )
                            shape = new window.google.maps.Rectangle(shapeOptions)
                            this.shapes.push(shape)
                          } else {
                            console.warn(`Incomplete rectangle shape data for range ID: ${range.id}`)
                          }
                          break
                        case 'circle':
                          if (range.shape.centerLat && range.shape.centerLng && range.shape.centerRadius) {
                            shapeOptions.center = new window.google.maps.LatLng(range.shape.centerLat, range.shape.centerLng)
                            shapeOptions.radius = range.shape.centerRadius
                            shape = new window.google.maps.Circle(shapeOptions)
                            this.shapes.push(shape)
                          } else {
                            console.warn(`Incomplete circle shape data for range ID: ${range.id}`)
                          }
                          break
                        case 'polygon':
                          if (range.shape.array && range.shape.array.length) {
                            shapeOptions.paths = range.shape.array.map(point => {
                              if (point.lat && point.lng) {
                                return new window.google.maps.LatLng(point.lat, point.lng)
                              } else {
                                console.warn(`Incomplete polygon path data for range ID: ${range.id}`)
                                return null
                              }
                            }).filter(latLng => latLng !== null)
                            if (shapeOptions.paths.length > 0) {
                              shape = new window.google.maps.Polygon(shapeOptions)
                              this.shapes.push(shape)
                            }
                          } else {
                            console.warn(`Incomplete polygon shape data for range ID: ${range.id}`)
                          }
                          break
                        default:
                          console.warn(`Unknown shape type: ${range.shape.type}`)
                          break
                      }
                      // Adaugă InfoWindow cu numele zonei la centrul formei
                      if (shape) {
                        let infoWindow = new window.google.maps.InfoWindow({
                          content: `<div><strong>${range.name}</strong></div>`
                        })

                        shape.addListener('click', () => {
                          // Setează poziția InfoWindow în funcție de tipul formei
                          let position
                          if (shape instanceof window.google.maps.Circle) {
                            position = shape.getCenter()
                          } else if (shape instanceof window.google.maps.Rectangle) {
                            position = shape.getBounds().getCenter()
                          } else if (shape instanceof window.google.maps.Polygon) {
                            let bounds = new window.google.maps.LatLngBounds()
                            shape.getPath().forEach(latlng => bounds.extend(latlng))
                            position = bounds.getCenter()
                          }
                          infoWindow.setPosition(position)
                          infoWindow.open(map)
                        })
                      }
                    } else {
                      console.warn(`Missing shape data for range ID: ${range.id}`)
                    }
                  })
                } else {
                  console.warn(`No ranges data available for location ID: ${loc.id}`)
                }
              }
            } else {
              console.warn(`Missing lat/lng data for location ID: ${loc.id}`)
            }
          }
        })

        // Adaugă marker-e pentru livratori selectați
        if (this.selectedButtons.includes('delivery') && this.working_drivers) {
          this.working_drivers.forEach(driver => {
            if (driver.last_gps_location && driver.last_gps_location.lat && driver.last_gps_location.lng) {
              let position = new window.google.maps.LatLng(driver.last_gps_location.lat, driver.last_gps_location.lng)
              // Verifică dacă șoferul are comenzi
              let orderCount = driver.orders ? driver.orders.length : 0
              // Setează iconul în funcție de starea comenzilor
              let iconUrl
              if (driver.avatar) {
                // Use the driver's avatar if available
                iconUrl = driver.avatar
              } else {
                const backgroundColor = orderCount > 0 ? '#ff4d4d' : '#17B086'
                // Use initials if no avatar is available
                const initials = `${driver.firstname[0]}${driver.lastname[0]}`.toUpperCase()
                // Create a data URL for the fallback image
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                const size = 32
                const radius = size / 2
                canvas.width = size
                canvas.height = size

                // Desenează fundalul circular
                ctx.beginPath()
                ctx.arc(radius, radius, radius, 0, 2 * Math.PI)
                ctx.fillStyle = backgroundColor
                ctx.fill()

                // Desenează inițialele centrate în cerc
                ctx.fillStyle = '#fff' // Culoarea textului
                ctx.textAlign = 'center'
                ctx.textBaseline = 'middle'
                ctx.font = 'bold 14px Arial'
                ctx.fillText(initials, radius, radius)

                // Desenează codita (triunghiul)
                ctx.beginPath()
                const tailSize = 8 // Size of the tail
                const tailOffset = 8 // Distance from the circle's bottom to the base of the tail
                ctx.moveTo(radius - tailSize, size - tailOffset) // Starting point of the tail
                ctx.lineTo(radius + tailSize, size - tailOffset) // Ending point of the tail
                ctx.lineTo(radius, size - tailOffset + tailSize) // Tip of the tail (pointed downward)
                ctx.closePath()
                ctx.fillStyle = backgroundColor
                ctx.fill()

                // Creează URL-ul pentru iconița din canvas
                iconUrl = canvas.toDataURL()
              }
              let iconSize = new window.google.maps.Size(32, 32)

              let marker = new window.google.maps.Marker({
                position: position,
                title: `${driver.firstname} ${driver.lastname}`,
                icon: {
                  url: iconUrl,
                  scaledSize: iconSize
                }
              })
              marker.setMap(map)
              // Creează un InfoWindow
              let infoWindow = new window.google.maps.InfoWindow({
                content: `
                  <div>
                    <strong>${driver.firstname} ${driver.lastname}</strong><br>
                    ID: ${driver.email}<br>
                    Orders: ${orderCount}<br>
                    ${driver.phone ? `Phone: ${driver.phone}<br>` : ''}
                  </div>
                `
              })

              // Adaugă un eveniment de clic pe marker pentru a afișa InfoWindow
              marker.addListener('click', () => {
                infoWindow.open(map, marker)
              })

              this.markers.push(marker)
            }
          })
        }

        // Adaugă marker-e pentru adresele de livrare
        if (this.selectedButtons.includes('orders') && this.orders) {
          this.orders.forEach(order => {
            if (order.address_billing && order.address_billing.lat && order.address_billing.lng) {
              let position = new window.google.maps.LatLng(order.address_billing.lat, order.address_billing.lng)
              let marker = new window.google.maps.Marker({
                position: position,
                title: order.address_billing.address_name, // Folosește numele adresei
                icon: {
                  url: '/static/img/food.png', // Calea către imaginea personalizată
                  scaledSize: new window.google.maps.Size(32, 32) // Dimensiunea icon-ului
                }
              })
              marker.setMap(map)

              // Creează un InfoWindow
              let infoWindow = new window.google.maps.InfoWindow({
                content: `<div><strong>${order.address_billing.address_name}</strong><br>${order.address_billing.formatted_address}</div>`
              })

              // Adaugă un eveniment de clic pe marker pentru a afișa InfoWindow
              marker.addListener('click', () => {
                infoWindow.open(map, marker)
              })

              this.markers.push(marker)
            }
          })
        }

        // Centrează harta pentru a include toți markerii
        console.log('User interacted with map:', this.userInteractedMap)
        if (!this.userInteractedMap) {
          this.centerMap(map)
        }
      },
      centerMap (map) {
        if (!map || !window.google || !window.google.maps) {
          return
        }

        // Creează un LatLngBounds pentru a include toți markerii
        if (this.markers.length > 0) {
          let bounds = new window.google.maps.LatLngBounds()

          this.markers.forEach(marker => {
            bounds.extend(marker.getPosition())
          })

          map.fitBounds(bounds) // Ajustează zoom-ul pentru a include toți markerii
          window.google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
            let currentZoom = map.getZoom()
            let targetZoom = 22

            // Dacă zoomul calculat este mai mare decât 11, atunci setează la targetZoom
            if (currentZoom > targetZoom) {
              map.setZoom(targetZoom)
            }
          })
        } else {
          // Dacă nu sunt marker-e, centrează harta la poziția inițială
          map.setCenter(new window.google.maps.LatLng(44.4268, 26.1025))
          map.setZoom(11)
        }
      },
      resetMap () {
        this.userInteractedMap = false
        this.updateMapMarkers(this.map)
      },
      highlightOrderOnMap (orderId) {
        if (!window.google || !window.google.maps) {
          console.error('Google Maps API is not loaded or not available.')
          return
        }
        // Curăță marker-ele existente (dacă este necesar)
        // if (this.markers && this.markers.length) {
        //   this.markers.forEach(marker => marker.setMap(null))
        //   this.markers = []
        // }

        // Găsește comanda în `orders`
        const order = this.orders.find(o => o.id === orderId)

        if (order && order.address_shipping && order.address_shipping.lat && order.address_shipping.lng) {
          const position = new window.google.maps.LatLng(order.address_shipping.lat, order.address_shipping.lng)

          // Creează un marker pentru locația comenzii
          const marker = new window.google.maps.Marker({
            position: position,
            title: `Comanda #${orderId}`,
            icon: {
              url: '/static/img/food.png',
              scaledSize: new window.google.maps.Size(32, 32)
            }
          })

          // Adaugă marker-ul pe hartă
          marker.setMap(this.map)

          // Centrează harta pe locația comenzii
          this.map.setCenter(position)

          // Zoom pe locația comenzii
          this.map.setZoom(15)

          // Închide `InfoWindow` anterior dacă există
          if (this.currentInfoWindow) {
            this.currentInfoWindow.close()
          }

          // Creează un InfoWindow pentru a afișa detalii despre comandă
          const infoWindow = new window.google.maps.InfoWindow({
            content: `<div><strong>Comanda #${orderId}</strong><br>${order.address_shipping.formatted_address}</div>`
          })

          // Deschide noul InfoWindow
          infoWindow.open(this.map, marker)

          // Salvează referința la InfoWindow-ul curent
          this.currentInfoWindow = infoWindow

          // Adaugă un eveniment de click pe marker pentru a afișa InfoWindow
          marker.addListener('click', () => {
            // Închide `InfoWindow` anterior dacă există
            if (this.currentInfoWindow) {
              this.currentInfoWindow.close()
            }

            // Deschide noul InfoWindow și actualizează referința
            infoWindow.open(this.map, marker)
            this.currentInfoWindow = infoWindow
          })

          // Salvează marker-ul în `this.markers` pentru a-l putea șterge mai târziu, dacă este necesar
          this.markers.push(marker)
          this.selectedOrderId = orderId
        } else {
          console.error('Locația pentru această comandă nu este disponibilă.')
        }
      },
      showDriverOnMap (driver) {
        if (!driver || !driver.last_gps_location || !driver.last_gps_location.lat || !driver.last_gps_location.lng) {
          swal({
            title: 'Error',
            text: 'Driver location is not available.',
            type: 'error',
            timer: 1500,
            showConfirmButton: false
          })
          return
        }

        const position = new window.google.maps.LatLng(driver.last_gps_location.lat, driver.last_gps_location.lng)
        let iconUrl
        if (driver.avatar && !driver.avatar.includes('noface.png')) {
          // Use the driver's avatar if available
          iconUrl = driver.avatar
        } else {
          const backgroundColor = '#ff4d4d'
          // Use initials if no avatar is available
          const initials = `${driver.firstname[0]}${driver.lastname[0]}`.toUpperCase()
          // Create a data URL for the fallback image
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          const size = 32
          const radius = size / 2
          canvas.width = size
          canvas.height = size

          // Desenează fundalul circular
          ctx.beginPath()
          ctx.arc(radius, radius, radius, 0, 2 * Math.PI)
          ctx.fillStyle = backgroundColor
          ctx.fill()

          // Desenează inițialele centrate în cerc
          ctx.fillStyle = '#fff' // Culoarea textului
          ctx.textAlign = 'center'
          ctx.textBaseline = 'middle'
          ctx.font = 'bold 14px Arial'
          ctx.fillText(initials, radius, radius)

          // Desenează codita (triunghiul)
          ctx.beginPath()
          const tailSize = 8 // Size of the tail
          const tailOffset = 8 // Distance from the circle's bottom to the base of the tail
          ctx.moveTo(radius - tailSize, size - tailOffset) // Starting point of the tail
          ctx.lineTo(radius + tailSize, size - tailOffset) // Ending point of the tail
          ctx.lineTo(radius, size - tailOffset + tailSize) // Tip of the tail (pointed downward)
          ctx.closePath()
          ctx.fillStyle = backgroundColor
          ctx.fill()

          // Creează URL-ul pentru iconița din canvas
          iconUrl = canvas.toDataURL()
        }

        // Create a marker for the driver's location
        let iconSize = new window.google.maps.Size(32, 32)

        let marker = new window.google.maps.Marker({
          position: position,
          title: `${driver.firstname} ${driver.lastname}`,
          icon: {
            url: iconUrl,
            scaledSize: iconSize
          }
        })

        // Add marker to the map
        marker.setMap(this.map)

        // Center and zoom the map to the driver's location
        this.map.setCenter(position)
        this.map.setZoom(11)

        // Optional: Show an InfoWindow with the driver's details
        const infoWindowContent = `
          <div>
            <strong>${driver.firstname} ${driver.lastname}</strong><br>
            Phone: ${driver.phone ? driver.phone : 'N/A'}<br>
            Driver's current location
          </div>
        `

        const infoWindow = new window.google.maps.InfoWindow({
          content: infoWindowContent
        })

        infoWindow.open(this.map, marker)

        // Close any previous InfoWindow if needed
        if (this.currentInfoWindow) {
          this.currentInfoWindow.close()
        }

        // Save the reference to the current InfoWindow
        this.currentInfoWindow = infoWindow

        // Open the InfoWindow when the marker is clicked
        marker.addListener('click', () => {
          infoWindow.open(this.map, marker)
        })

        // Save the marker to an array if you need to remove it later
        this.markers.push(marker)
      },
      showDriverModal (orderId) {
        this.selectedOrderId = orderId
        this.getDriversForOrder(this.selectedOrderId)
      },
      hideDriverModal () {
        this.$modal.hide('driverModal')
      },
      loadDriverData () {
        this.driverTableData = this.api_drivers.map(driver => {
          const name = `${driver.firstname} ${driver.lastname}`
          const orderCount = driver.orders ? driver.orders.length : 0
          const distance = driver.air_distance !== null && driver.air_distance !== undefined
            ? `${driver.air_distance} km`
            : 'N/A'
          const hasAssignedOrder = driver.orders && driver.orders.some(order => order.id === this.selectedOrderId)

          return {
            id: driver.id,
            name: name,
            orders: orderCount > 0 ? orderCount : 'Free',
            distance: distance,
            hasAssignedOrder: hasAssignedOrder,
            canAssign: !this.selectedOrderAssigned || hasAssignedOrder
          }
        })
      },
      assignDriver (driver) {
        // Check if assigning from a group or a single order
        if (this.groupId) {
          // Assigning from a group
          const dataToSend = {
            driver_id: driver.id,
            group_id: this.groupId,
            company_id: this.$session.get('selectedCompany'),
            token: this.$session.get('token')
          }

          this.apiRequest('/dispatch-assign-group-to-driver', 'POST', dataToSend, (response) => {
            if (response.status === true) {
              this.loading = false
              swal({
                title: 'Success',
                text: 'Driver assigned successfully to the group.',
                type: 'success',
                timer: 1500,
                showConfirmButton: false
              })
              this.loadDriverData()
              this.getData()
              this.hideDriverModal()
            } else {
              const errorMessage = response.errors.order || 'Failed to assign driver to the group.'
              swal({
                title: 'Error',
                text: errorMessage,
                type: 'error',
                timer: 1500,
                showConfirmButton: false
              })
            }
          }, (error) => {
            console.error('Error:', error)
            swal({
              title: 'Error',
              text: 'An error occurred while assigning the driver to the group.',
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            })
          })
        } else {
          // Pregătește datele pentru cererea API
          const dataToSend = {
            to: driver.id,
            from: 0,
            orderId: this.selectedOrderId,
            company_id: this.$session.get('selectedCompany'),
            token: this.$session.get('token')
          }

          // Trimite cererea API folosind apiRequest
          this.apiRequest('/dispatch', 'POST', dataToSend, (response) => {
            if (response.status === true) {
              this.loading = false
              swal({
                title: 'Success',
                text: 'Driver assigned successfully.',
                type: 'success',
                timer: 1500,
                showConfirmButton: false
              })
              this.selectedOrderAssigned = true
              this.loadDriverData() // Reîncarcă datele pentru a reflecta schimbările
              this.getData()
              this.hideDriverModal()
            } else {
              swal({
                title: 'Error',
                text: 'Failed to assign driver.',
                type: 'error',
                timer: 1500,
                showConfirmButton: false
              })
            }
          }, (error) => {
            console.error('Error:', error)
            swal({
              title: 'Error',
              text: 'An error occurred while assigning the driver.',
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            })
          })
        }
      },
      unassignDriver (driver) {
        const dataToSend = {
          to: 0,
          from: driver.id,
          orderId: this.selectedOrderId,
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token')
        }

        this.apiRequest('/dispatch', 'POST', dataToSend, (response) => {
          if (response.status === true) {
            this.loading = false
            swal({
              title: 'Success',
              text: 'Driver unassigned successfully.',
              type: 'success',
              timer: 1500,
              showConfirmButton: false
            })
            this.selectedOrderAssigned = false
            this.loadDriverData() // Reîncarcă datele pentru a reflecta schimbările
            this.getData()
            this.hideDriverModal() // Închide modalul
          } else {
            swal({
              title: 'Error',
              text: 'Failed to unassign driver.',
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            })
          }
        }, (error) => {
          console.error('Error:', error)
          swal({
            title: 'Error',
            text: 'An error occurred while unassigning the driver.',
            type: 'error',
            timer: 1500,
            showConfirmButton: false
          })
        })
      },
      sendOrderToPrintSections (orderId, printToIp) {
        swal({
          title: 'Printing Sections',
          html: 'Please wait...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          onOpen: () => {
            swal.showLoading()
          }
        })

        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          order_id: orderId
        }

        this.apiRequest('/get-order-for-local-printer', 'POST', data, (response) => {
          if (response.status) {
            const sectionDataToSendToLocal = {
              order: response.data.order,
              printers: response.data.printers
            }

            const receiptDataToSendToLocal = {
              order: response.data.order,
              printers: response.data.printersForReceipt
            }

            let $msg = ''
            let oneErrorMsg = 'success'

            if (response.data.printers.length) {
              this.localRequest(printToIp, '/print-sections', 'POST', sectionDataToSendToLocal, (sectionRsp) => {
                if (sectionRsp.status === 200) {
                  sectionRsp.data.data.forEach(printerResponse => {
                    if (printerResponse.status) {
                      if (printerResponse.message && printerResponse.message === 'No items to print') {
                        return
                      }
                      $msg += 'Sectia: ' + printerResponse.printerSectionName + ' s-a printat cu succes!\n'
                    } else {
                      $msg += 'Eroare sectia: ' + printerResponse.printerSectionName + '\n'
                      oneErrorMsg = 'error'
                    }
                  })
                } else {
                  $msg += `Eroare: sectiuni - ${printToIp} inaccesibil sau proxy nu functioneaza.\n`
                  oneErrorMsg = 'error'
                }

                if (response.data.printersForReceipt.length) {
                  this.localRequest(printToIp, '/print', 'POST', receiptDataToSendToLocal, (receiptRsp) => {
                    if (receiptRsp.status === 200) {
                      receiptRsp.data.data.forEach(printerResponse => {
                        if (printerResponse.status) {
                          $msg += 'Nota de plata s-a printat cu succes!\n'
                        } else {
                          $msg += 'Eroare nota de plata' + '\n'
                          oneErrorMsg = 'error'
                        }
                      })
                    } else {
                      $msg += `Eroare: bonuri - ${printToIp} inaccesibil sau proxy nu functioneaza.\n`
                      oneErrorMsg = 'error'
                    }
                  })
                }
                swal({
                  title: oneErrorMsg === 'success' ? 'Succes!' : 'Rezultat printare',
                  html: $msg.replace(/\n/g, '<br>'),
                  type: oneErrorMsg,
                  confirmButtonText: 'OK',
                  allowOutsideClick: false
                })
              })
            } else if (response.data.printersForReceipt.length) {
              this.localRequest(printToIp, '/print', 'POST', receiptDataToSendToLocal, (receiptRsp) => {
                if (receiptRsp.status === 200) {
                  receiptRsp.data.data.forEach(printerResponse => {
                    if (printerResponse.status) {
                      $msg += 'Nota de plata s-a printat cu succes!\n'
                    } else {
                      $msg += 'Eroare nota de plata' + '\n'
                      oneErrorMsg = 'error'
                    }
                  })
                } else {
                  $msg += `Eroare: bonuri - ${printToIp} inaccesibil sau proxy nu functioneaza.\n`
                  oneErrorMsg = 'error'
                }

                swal({
                  title: oneErrorMsg === 'success' ? 'Succes!' : 'Rezultat printare',
                  html: $msg.replace(/\n/g, '<br>'),
                  type: oneErrorMsg,
                  confirmButtonText: 'OK',
                  allowOutsideClick: false
                })
              })
            }
          } else {
            swal({
              title: 'Error',
              text: 'Failed to load order for printing',
              type: 'error',
              confirmButtonText: 'OK'
            })
          }
        })
      },
      updateStatus (orderId, newStatus) {
        var self = this

        swal({
          text: `Are you sure you want to update the order status to ${newStatus}?`,
          type: 'question',
          position: 'top-end',
          showCancelButton: true,
          cancelButtonText: 'Cancel',
          confirmButtonText: 'Confirm',
          allowOutsideClick: false,
          reverseButtons: true
        }).then((result) => {
          if (result) {
            const data = {
              id: orderId,
              token: self.$session.get('token'),
              company_id: self.$session.get('selectedCompany'),
              status: newStatus
            }

            // Trimite cererea API folosind self.apiRequest
            self.apiRequest('/order/' + orderId, 'PUT', data, function (response) {
              if (response.status === true) {
                swal({
                  title: 'Success',
                  text: 'Order status updated successfully.',
                  type: 'success',
                  timer: 1500,
                  showConfirmButton: false
                })

                if (newStatus === 'PROCESSING') {
                  const printToIp = JSON.parse(self.$session.get('userData')).server_ip_port
                  if (printToIp && printToIp !== '') {
                    self.sendOrderToPrintSections(orderId, printToIp)
                  }
                }

                // Actualizează lista de comenzi
                self.getData()
              } else {
                swal({
                  title: 'Error',
                  text: 'Failed to update order status.',
                  type: 'error',
                  timer: 1500,
                  showConfirmButton: false
                })
              }
            }, function (error) {
              console.error('Error:', error)
              swal({
                title: 'Error',
                text: 'An error occurred while updating the status.',
                type: 'error',
                timer: 1500,
                showConfirmButton: false
              })
            })
          }
        }).catch((error) => {
          console.error('Swal Error:', error)
        })
      },
      getStatusClass (status, driver) {
        if (status === 'NEW') {
          return 'status-new'
        } else if (status === 'PROCESSING') {
          return 'status-processing'
        } else if (status === 'PREPARED') {
          return driver ? 'status-prepared-driver' : 'status-prepared-no-driver'
        } else if (status === 'TRANSPORT') {
          return 'status-transport'
        } else if (status === 'NOT_DELIVERED') {
          return 'status-not-delivered'
        } else {
          return ''
        }
      },
      getStatusText (status, driver) {
        if (status === 'PREPARED') {
          return driver ? this.$t('dispath.assign') : 'prepared'
        }
        return status.toLowerCase()
      },
      showOrdersPosModal () {
        this.$modal.show('ordersPosModal')
      },
      hideOrdersPosModal () {
        this.$modal.hide('ordersPosModal')
      },
      showOrdersViewModal (orderId) {
        this.iframeSrc = `/orders/view/${orderId}`
        this.$modal.show('ordersViewModal')
      },
      hideOrdersViewModal () {
        this.$modal.hide('ordersViewModal')
        this.orderId = null
      },
      showLocationModal (orderId) {
        this.currentOrderId = orderId
        this.$modal.show('changeLocation')
      },
      hideLocationModal () {
        this.$modal.hide('changeLocation')
      },
      showAddOrdersGroupModal () {
        this.getDispatchCheckIfGroupingIsPossible()
        this.$modal.show('ordersGroupModal')
      },
      hideAddOrdersGroupModal () {
        this.$modal.hide('ordersGroupModal')
        this.getData()
      },
      changeOrderLocation (locationId) {
        const dataToSend = {
          order_id: this.currentOrderId,
          new_location_id: locationId,
          token: this.$session.get('token')
        }
        // Make the API request
        this.apiRequest('/dispatch-change-order-location', 'POST', dataToSend, (response) => {
          if (response.status === true) {
            swal({
              title: 'Success',
              text: this.$t('general.changeOrderLocationSuccess'),
              type: 'success',
              timer: 1500,
              showConfirmButton: false
            })
            this.getData()
            this.hideLocationModal() // Hide the modal on success
          } else {
            swal({
              title: 'Error',
              text: this.$t('general.changeOrderLocationFailed'),
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            })
          }
        })
      },
      getDispatchCheckIfGroupingIsPossible () {
        const dataToSend = {
          token: this.$session.get('token')
        }

        this.apiRequest('/dispatch-check-if-grouping-is-possible', 'GET', dataToSend, (response) => {
          if (response.status === true) {
            this.groupingOrders = response.data.orders
            this.groupingOrdersByZone = response.data.grouped_orders_by_zone
            this.groups = response.data.groups.map(group => ({
              ...group,
              orders_suggestions: group.orders_suggestions || []
            }))
          } else {
            console.error('Grouping check failed:', response.message)
          }
        })
      },
      removeOrderGroup (group, orderId) {
        const groupId = group.id
        const dataToSend = {
          token: this.$session.get('token'),
          order_id: orderId,
          group_id: groupId
        }

        this.apiRequest('/dispatch-remove-order-from-group', 'POST', dataToSend, (response) => {
          if (response.status === true) {
            const index = group.orders.findIndex(order => order.id === orderId)
            if (index !== -1) {
              group.orders.splice(index, 1)
            }
            this.getDispatchCheckIfGroupingIsPossible()
          } else {
            console.error('Failed to remove order:', response.message)
          }
        })
      },
      removeOrderGroupPosibile (group, orderId) {
        const orderIndex = group.orders.findIndex(order => order.id === orderId)
        if (orderIndex !== -1) {
          group.orders.splice(orderIndex, 1)
        }
      },
      addOrderGroupPosibile (group, orderId) {
        const dataToSend = {
          token: this.$session.get('token'),
          orders_ids: [orderId],
          group_id: group.id
        }

        this.apiRequest('/dispatch-add-order-in-group', 'POST', dataToSend, (response) => {
          if (response.status === true) {
            swal({
              title: 'Success',
              text: this.$t('dispath.addOrderGroupPosibileSuccess'),
              type: 'success',
              timer: 1500,
              showConfirmButton: false
            })
            this.getDispatchCheckIfGroupingIsPossible()
          } else {
            swal({
              title: 'Error',
              text: this.$t('dispath.addOrderGroupPosibileError'),
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            })
          }
        })
      },
      createOrderGroup (group) {
        const ordersIds = group.orders.map(order => order.id)
        const dataToSend = {
          token: this.$session.get('token'),
          orders_ids: ordersIds
        }
        this.apiRequest('/dispatch-create-order-group', 'POST', dataToSend, (response) => {
          if (response.status === true) {
            swal({
              title: 'Success',
              text: this.$t('dispath.createOrderGroupSuccess'),
              type: 'success',
              timer: 1500,
              showConfirmButton: false
            })
            this.getDispatchCheckIfGroupingIsPossible()
          } else {
            swal({
              title: 'Error',
              text: this.$t('dispath.createOrderGroupError'),
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            })
          }
        })
      },
      // Funcția declanșată când o comandă este mutată într-un grup
      onDropOrder (event) {
        const fromGroup = parseInt(event.from.getAttribute('data-group_id'))
        const toGroupId = parseInt(event.to.getAttribute('data-group_id'))
        const movedOrderId = event.item.dataset.orderId
        // Verificăm dacă comanda este mutată din 'unassign order' în grupuri
        if (!fromGroup && toGroupId) {
          this.addOrderToGroup(toGroupId, movedOrderId)
        } else {
          console.log('Comanda nu se poate muta decât din coloana de comenzi nealocate în grupuri.')
        }
      },
      addOrderToGroup (groupId, orderId) {
        const dataToSend = {
          token: this.$session.get('token'),
          orders_ids: [orderId],
          group_id: groupId
        }

        this.apiRequest('/dispatch-add-order-in-group', 'POST', dataToSend, (response) => {
          if (response.status === true) {
            console.log('Order successfully added to group:', response.data)
          } else {
            console.error('Failed to add order to group:', response.message)
          }
        })
      },
      addGroupOrderDriverModal (groupId) {
        const group = this.groupsDispatch.find(g => g.id === groupId)
        if (group) {
          if (group.orders && group.orders.length) {
            this.groupId = groupId
            this.selectedOrderId = group.orders[0].id
            this.getDriversForOrder(this.selectedOrderId)
          } else {
            swal({
              title: 'Error',
              text: 'No orders available for this group.',
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            })
          }
        }
      },
      openFiltersModal () {
        this.modalRequestFilters = [{
          value: JSON.parse(JSON.stringify(this.requestFilters[0].value))
        }]
        this.modalLocationFilter = this.normalizeLocationFilter(this.locationFilter)
        this.modalSortOrder = parseInt(this.sortOrder) || 1

        let pickupDatetime = null
        if (this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2) {
          pickupDatetime = [
            this.orderFilters.pickupDatetime[0],
            this.adjustEndTime(this.orderFilters.pickupDatetime[1])
          ]
        }

        let placedDatetime = null
        if (this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2) {
          placedDatetime = [
            this.orderFilters.placedDatetime[0],
            this.adjustEndTime(this.orderFilters.placedDatetime[1])
          ]
        }

        this.modalOrderFilters = {
          pickupDatetime: pickupDatetime,
          placedDatetime: placedDatetime,
          orderId: this.orderFilters.orderId,
          orderNumber: this.orderFilters.orderNumber,
          orderTotalMin: this.orderFilters.orderTotalMin,
          orderTotalMax: this.orderFilters.orderTotalMax,
          operator: JSON.parse(JSON.stringify(this.orderFilters.operator)),
          paymentType: JSON.parse(JSON.stringify(this.orderFilters.paymentType)),
          deliveryType: JSON.parse(JSON.stringify(this.orderFilters.deliveryType)),
          source: JSON.parse(JSON.stringify(this.orderFilters.source))
        }
        this.$modal.show('dispatchFiltersModal')
      },
      applyFilters () {
        this.isModalFilterChange = true

        this.requestFilters[0].value = JSON.parse(JSON.stringify(this.modalRequestFilters[0].value))
        this.locationFilter = this.normalizeLocationFilter(this.modalLocationFilter)
        this.sortOrder = this.modalSortOrder

        let pickupDatetime = null
        if (this.modalOrderFilters.pickupDatetime && this.modalOrderFilters.pickupDatetime.length === 2) {
          pickupDatetime = [
            this.modalOrderFilters.pickupDatetime[0],
            this.adjustEndTime(this.modalOrderFilters.pickupDatetime[1])
          ]
        }

        let placedDatetime = null
        if (this.modalOrderFilters.placedDatetime && this.modalOrderFilters.placedDatetime.length === 2) {
          placedDatetime = [
            this.modalOrderFilters.placedDatetime[0],
            this.adjustEndTime(this.modalOrderFilters.placedDatetime[1])
          ]
        }

        this.orderFilters = {
          pickupDatetime: pickupDatetime,
          placedDatetime: placedDatetime,
          orderId: this.modalOrderFilters.orderId,
          orderNumber: this.modalOrderFilters.orderNumber,
          orderTotalMin: this.normalizeOrderTotal(this.modalOrderFilters.orderTotalMin),
          orderTotalMax: this.normalizeOrderTotal(this.modalOrderFilters.orderTotalMax),
          operator: JSON.parse(JSON.stringify(this.modalOrderFilters.operator)),
          paymentType: JSON.parse(JSON.stringify(this.modalOrderFilters.paymentType)),
          deliveryType: JSON.parse(JSON.stringify(this.modalOrderFilters.deliveryType)),
          source: JSON.parse(JSON.stringify(this.modalOrderFilters.source))
        }

        this.$modal.hide('dispatchFiltersModal')

        this.$nextTick(() => {
          this.isModalFilterChange = false
          this.refreshDispatchData()
        })
      },
      resetModalFilters () {
        this.modalRequestFilters[0].value = DEFAULT_DISPATCH_STATUSES.slice()
        this.modalLocationFilter = []
        this.modalSortOrder = 1
        this.modalOrderFilters = {
          pickupDatetime: null,
          placedDatetime: null,
          orderId: '',
          orderNumber: '',
          orderTotalMin: null,
          orderTotalMax: null,
          operator: [],
          paymentType: [],
          deliveryType: DEFAULT_DISPATCH_DELIVERY_TYPES.slice(),
          source: []
        }

        this.requestFilters[0].value = DEFAULT_DISPATCH_STATUSES.slice()
        this.locationFilter = []
        this.sortOrder = this.modalSortOrder
        this.orderFilters = {
          pickupDatetime: null,
          placedDatetime: null,
          orderId: '',
          orderNumber: '',
          orderTotalMin: null,
          orderTotalMax: null,
          operator: [],
          paymentType: [],
          deliveryType: DEFAULT_DISPATCH_DELIVERY_TYPES.slice(),
          source: []
        }
        this.refreshDispatchData()
      },
      resetFilters () {
        this.requestFilters[0].value = DEFAULT_DISPATCH_STATUSES.slice()
        this.locationFilter = []
        this.orderFilters = {
          pickupDatetime: null,
          placedDatetime: null,
          orderId: '',
          orderNumber: '',
          orderTotalMin: null,
          orderTotalMax: null,
          operator: [],
          paymentType: [],
          deliveryType: DEFAULT_DISPATCH_DELIVERY_TYPES.slice(),
          source: []
        }
        this.sortOrder = 1
        this.refreshDispatchData()
      },
      removeStatusFilter (index) {
        this.requestFilters[0].value.splice(index, 1)
        this.refreshDispatchData()
      },
      removeLocationFilter (index) {
        this.locationFilter.splice(index, 1)
        this.refreshDispatchData()
      },
      removePickupDatetimeFilter () {
        this.orderFilters.pickupDatetime = null
        this.refreshDispatchData()
      },
      removePlacedDatetimeFilter () {
        this.orderFilters.placedDatetime = null
        this.refreshDispatchData()
      },
      removeOrderIdFilter () {
        this.orderFilters.orderId = ''
        this.refreshDispatchData()
      },
      removeOrderNumberFilter () {
        this.orderFilters.orderNumber = ''
        this.refreshDispatchData()
      },
      removeOrderTotalFilter () {
        this.orderFilters.orderTotalMin = null
        this.orderFilters.orderTotalMax = null
        this.refreshDispatchData()
      },
      removeOperatorFilter (index) {
        if (index !== undefined) {
          this.orderFilters.operator.splice(index, 1)
        } else {
          this.orderFilters.operator = []
        }
        this.refreshDispatchData()
      },
      removePaymentTypeFilter (index) {
        if (index !== undefined) {
          this.orderFilters.paymentType.splice(index, 1)
        } else {
          this.orderFilters.paymentType = []
        }
        this.refreshDispatchData()
      },
      removeDeliveryTypeFilter (index) {
        if (index !== undefined) {
          this.orderFilters.deliveryType.splice(index, 1)
        } else {
          this.orderFilters.deliveryType = []
        }
        this.refreshDispatchData()
      },
      removeSourceFilter (index) {
        if (index !== undefined) {
          this.orderFilters.source.splice(index, 1)
        } else {
          this.orderFilters.source = []
        }
        this.refreshDispatchData()
      },
      toggleModalStatusFilter (key) {
        const idx = this.modalRequestFilters[0].value.indexOf(key)
        if (idx === -1) {
          this.modalRequestFilters[0].value.push(key)
        } else {
          this.modalRequestFilters[0].value.splice(idx, 1)
        }
      },
      toggleModalPaymentTypeFilter (paymentType) {
        if (!this.modalOrderFilters.paymentType) {
          this.modalOrderFilters.paymentType = []
        }
        const idx = this.modalOrderFilters.paymentType.indexOf(paymentType)
        if (idx === -1) {
          this.modalOrderFilters.paymentType.push(paymentType)
        } else {
          this.modalOrderFilters.paymentType.splice(idx, 1)
        }
      },
      toggleModalDeliveryTypeFilter (deliveryType) {
        if (!this.modalOrderFilters.deliveryType) {
          this.modalOrderFilters.deliveryType = []
        }
        const idx = this.modalOrderFilters.deliveryType.indexOf(deliveryType)
        if (idx === -1) {
          this.modalOrderFilters.deliveryType.push(deliveryType)
        } else {
          this.modalOrderFilters.deliveryType.splice(idx, 1)
        }
      },
      toggleModalSourceFilter (src) {
        if (!this.modalOrderFilters.source) {
          this.modalOrderFilters.source = []
        }
        const idx = this.modalOrderFilters.source.indexOf(src)
        if (idx === -1) {
          this.modalOrderFilters.source.push(src)
        } else {
          this.modalOrderFilters.source.splice(idx, 1)
        }
      },
      toggleFiltersCollapse () {
        this.showFiltersCollapsed = !this.showFiltersCollapsed
      },
      getLocationFilterValue (loc) {
        if (loc.true_id != null && loc.true_id !== '') {
          return parseInt(loc.true_id, 10)
        }
        return loc.id
      },
      isLocationInFilter (loc) {
        return this.locationFilter.some(filterId => {
          const filterValue = parseInt(filterId, 10)
          const locId = parseInt(loc.id, 10)
          const locTrueId = loc.true_id != null ? parseInt(loc.true_id, 10) : null
          return filterValue === locId || (locTrueId != null && filterValue === locTrueId) ||
            filterId === loc.id || filterId === loc.true_id
        })
      },
      getLocationName (locationId) {
        const location = this.locations.find(loc => loc.true_id === locationId || loc.id === locationId)
        return location ? location.name : locationId
      },
      normalizeLocationFilter (locationFilter) {
        if (!locationFilter || !Array.isArray(locationFilter) || locationFilter.length === 0) {
          return []
        }
        const normalized = []
        for (const value of locationFilter) {
          const numValue = typeof value === 'string' ? parseInt(value, 10) : value
          const location = this.locations.find(loc => {
            if (loc.true_id === numValue || loc.true_id === value) return true
            if (loc.id === numValue || loc.id === value) return true
            if (typeof value === 'string') {
              return String(loc.true_id) === value || String(loc.id) === value
            }
            return false
          })
          if (location) {
            const filterValue = this.getLocationFilterValue(location)
            if (!normalized.includes(filterValue)) {
              normalized.push(filterValue)
            }
          }
        }
        return normalized
      },
      getOperatorName (operatorId) {
        const operator = this.operatorOptions.find(op => op.id === operatorId)
        return operator ? operator.label : operatorId
      },
      formatDateRange (dateRange) {
        if (!dateRange || dateRange.length !== 2) return ''
        return `${dateRange[0]} - ${dateRange[1]}`
      },
      normalizeOrderTotal (value) {
        if (value === null || value === undefined || value === '') {
          return null
        }
        const num = Number(value)
        // el-input-number turns empty fields into 0; do not treat that as a filter
        if (isNaN(num) || num === 0) {
          return null
        }
        return num
      },
      adjustEndTime (datetime) {
        if (datetime && datetime.endsWith('00:00:00')) {
          return datetime.replace('00:00:00', '23:59:59')
        }
        return datetime
      },
      adjustDatetimeRange (filterType) {
        if (this.modalOrderFilters[filterType] && this.modalOrderFilters[filterType].length === 2) {
          this.modalOrderFilters[filterType] = [
            this.modalOrderFilters[filterType][0],
            this.adjustEndTime(this.modalOrderFilters[filterType][1])
          ]
        }
      },
      formatLabelFirstLetter (translationKey) {
        try {
          const label = this.$t(translationKey)
          if (!label || typeof label !== 'string') {
            const fallback = translationKey.split('.').pop()
            return fallback ? fallback.toLowerCase().split(' ').map(word => {
              return word.charAt(0).toUpperCase() + word.slice(1)
            }).join(' ') : translationKey
          }
          return label.toLowerCase().split(' ').map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1)
          }).join(' ')
        } catch (e) {
          const key = translationKey.split('.').pop()
          return key ? key.toLowerCase().split(' ').map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1)
          }).join(' ') : translationKey
        }
      },
      getPosUsers () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/pos/all/users', 'GET', data, (response) => {
          if (response.status && response.data && response.data.pos_user) {
            this.operatorOptions = response.data.pos_user.map(user => ({
              id: user.id,
              label: `${user.firstname || ''} ${user.lastname || ''}`.trim() || `User ${user.id}`
            }))
          }
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  .height-95-vh {
    height: 95vh;
    overflow-x: auto;
  }
  .order.selected {
    .orderId {
      color: #fff;
    }
    .date {
      span {
        color: #fff;
      }
    }
  }
  .card-map{
      .full-screen-map{
          height: calc(100vh - 14em);
          margin-top: 20px;
      }
  }
  .modalDriver {
    .vm--modal {
      background-color: #F4F6FF;
      border-radius: 10px;
      width: 900px !important;
      left: 0px !important;
      right: 0px !important;
      margin: auto;
      .card {
        border: none;
        background-color: #F4F6FF;
        margin-bottom: 0px;
        .card-content {
          // padding: 15px 15px 10px 15px;
          .modal-body {
            padding: 0px;
          }
          .modal-header {
            padding: 0;
            border-bottom: none;
            .close {
              position: absolute;
              top: 12px;
              right: 12px;
            }
          }
        }
      }
    }
  }
  .changeLocation {
    .vm--modal {
      background-color: #F4F6FF;
      border-radius: 10px;
      width: 900px !important;
      left: 0px !important;
      right: 0px !important;
      margin: auto;
      .card {
        border: none;
        background-color: #F4F6FF;
        margin-bottom: 0px;
        .card-content {
          // padding: 15px 15px 10px 15px;
          .modal-body {
            padding: 0px;
          }
          .modal-header {
            padding: 0;
            border-bottom: none;
            .close {
              position: absolute;
              top: 12px;
              right: 12px;
            }
          }
        }
      }
    }
    .location-item {
      display: inline-block;
      font-size: 14px;
      font-weight: 400;
      text-transform: capitalize;
      color: #000;
      background-color: #E4E8F9;
      border: none;
      opacity: 1;
      padding: 13px 20px !important;
      margin: 10px;
      border-radius: 14px;
      cursor: pointer;
    }
  }
  .ordersGroupModal {
    .vm--modal {
      background-color: #F4F6FF;
      border-radius: 10px;
      width: 900px !important;
      left: 0px !important;
      right: 0px !important;
      margin: auto;
      .card {
        border: none;
        background-color: #F4F6FF;
        margin-bottom: 0px;
        .card-content {
          // padding: 15px 15px 10px 15px;
          .modal-body {
            padding: 0px;
          }
          .modal-header {
            padding: 0;
            border-bottom: none;
            .close {
              position: absolute;
              top: 12px;
              right: 12px;
            }
          }
        }
      }
    }
    .location-item {
      display: inline-block;
      font-size: 14px;
      font-weight: 400;
      text-transform: capitalize;
      color: #000;
      background-color: #E4E8F9;
      border: none;
      opacity: 1;
      padding: 13px 20px !important;
      margin: 10px;
      border-radius: 14px;
      cursor: pointer;
    }
  }
  .order {
    background: #E6EFFB;
    margin-bottom: 20px;
    border-radius: 20px;
    border: 1px solid #D9E6F8;
    position: relative;
    margin-left: 10px;
    margin-right: 10px;
    cursor: pointer;
      &.selected {
        background: #5420BE !important;
        border: 1px solid #5420BE !important;
      }
    .production_details {
        margin-bottom: 0px;
        text-align: end;
        > span {
          text-decoration: underline;
        }
        .zone {
          display: block;
          color: #FF0D19;
          text-decoration: none;
          b {
            color: #25396F;
          }
        }
    }
    .orderId {
      padding: 4px 6px;
      font-size: 14px;
      border-radius: 7px;
      color: #25396F;
      font-weight: 500;
      text-decoration: underline;
    }
    .date {
      img {
        margin-right: 5px;
        position: relative;
        bottom: 2px;
      }
      span {
        font-size: 13px;
        color: #25396F;
      }
    }
    .footer{
      display: flex;
      justify-content: center;
      align-items: center;
      .goToOrder {
        button {
          border-radius: 50px;
          padding: 10px 16px;
        }
      }
      .goToDriver {
        margin-right: 0px;
        margin-top: 5px;
        .assigned-driver {
          border: none;
          background: none;
          padding-right: 0px;
          &:hover {
            color: #0097FC;
          }
          &:active {
            color: #0097FC;
          }
        }
        button {
          border-radius: 50px;
          padding: 10px 16px;
        }
      }
      .updateStatus {
        margin-top: 5px;
        .btn-processing {
          background: #FEF1DC;
          color: #F39E1A;
          border: none;
          border: 1px solid #F39E1A;
          padding: 10px 16px;
          &:hover {
            background: #F39E1A;
            color: #fff;
          }
        }
        .btn-prepared {
          background: #EFECFB;
          color: #674BD2;
          border: none;
          border: 1px solid #674BD2;
          padding: 10px 16px;
          &:hover {
            background: #674BD2;
            color: #fff;
          }
        }
      }
    }
    &.transport {
      background: #f56c6c7a;
    }
    &.not_delivered {
      background: #f56c6c;
    }
    .buttons {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: end;
      button {
        width: 100%;
      }
    }
    .ord {
      padding: 10px 20px 10px 20px;
      margin-top: 10px;
      font-size: 14px;
      background: #fff;
      border-radius: 18px;
      position: relative;
      .phone {
        color: #66749A;
      }
      .ord_mid {
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        .client {
          width: 40%;
        }
        // .address {
        //   width: 60%;
        // }
        .zones {
          background: #FFEBEA;
          color: #FF0D19;
          padding: 6px 30px;
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
          position: absolute;
          top: 0;
          right: 20px;
        }
        .address_shipping {
          width: 100%;
          align-items: end !important;
          img {
            position: relative;
            bottom: 1px;
          }
        }
        .client,
        .address_shipping {
          margin: 5px 0px;
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          flex-direction: column;
        }
        .address_shipping {
          span {
            color: #66749A;
          }
        }
      }
    }
    .total {
      width: 65%;
      font-weight: 500;
      margin-top: 0px;
      font-size: 16px;
      .total span {
          font-size: 16px;
          position: absolute;
          bottom: 20px;
      }
    }
  }
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 8px;
    padding-bottom: 0px;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    .statusHeader {
      margin-right: 5px;
      .status-prepared-driver {
        background: #ff4d4d;
        color: #fff;
      }
      .status-prepared-no-driver {
        background: #1FC094;
        color: #fff;
      }
      .status-new {
        background-color: #0097FC !important;
        color: #fff;
      }
      .status-processing {
        background-color: #F3BB45;
        color: #fff;
      }
      .status-transport {
        background: #1FC094;
        color: #fff;
      }
      .status-not-delivered {
        background: #ff4d4d;
        color: #fff;
      }
      span {
        font-size: 12px;
        padding: 5px 18px;
        border-radius: 50px;
        text-transform: uppercase;
      }
    }
  }
  .col-orders {
    width: 32%;
    padding: 0px 0px 0px 0px;
    height: 100%;
    border-right: 1px solid #E6EFFB;
    background: #F4F6FF;
    .title {
        text-transform: uppercase;
    }
  }
  .col-maps {
    width: 100%;
    padding-left: 0px;
    background: #F4F6FF;
    height: 100%;
    .general-top-bar {
      background: #fff;
      padding-left: 10px;
      padding-right: 10px;
      margin: 0px;
    }
  }
  .ordersposContainer {
    border-radius: 10px;
    padding: 0px;
    // height: 100vh;
    .newOrder {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #E6EFFB;
      margin-bottom: 20px;
      padding-bottom: 3px;
      background: #fff;
      height: 88px;
      padding: 0px 10px;
      padding-bottom: 20px;
      .buttonAdd {
        margin: 0px;
      }
      .batched {
        button {
          background: #17B086 !important;
          border-color: #17B086 !important;
          color: #fff !important;
        }
      }
    }
    .statuses{
      gap: 2px;
      display: flex;
      width: 100%;
      margin-bottom: 20px;
      padding: 0px 10px;
      height: 40px;
      .status {
        border-color: white;
        width: auto;
        font-size: 12px;
        font-weight: 400;
        padding: 10px 0px;
        border-radius: 50px;
        width: 120px;
        text-align: center;
        display: flow;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        span {
          padding: 5px 3px;
          font-size: 14px !important;
          font-weight: 500;
          padding-bottom: 2px;
          border-radius: 0px !important;
        }
      }
      .status.new {
        // background: #E4F4FF;
        color: #0097FC;
        &.selected {
          // background-color: #68B3C8 !important;
          // color: white !important;
          span {
            border-bottom: 1px solid;
          }
        }
      }
      .status.processing {
        // background: #FEF1DC;
        color: #F39E1A;
        &.selected {
          // background-color: #F3BB45 !important;
          // color: white !important;
          span {
            border-bottom: 1px solid;
          }
        }
      }
      .status.prepared {
        // background: #EFECFB;
        color: #674BD2;
        &.selected {
          // background-color: #5e35b1 !important;
          // color: white !important;
          span {
            border-bottom: 1px solid;
          }
        }
      }
      .status.in-transport {
        &.selected {
          // background-color: #66615B !important;
          // color: white !important;
          span {
            border-bottom: 1px solid;
          }
        }
      }
    }
    .maps-buttons {
      padding: 0px 10px;
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: end;
      .checkbox {
        margin: 0px;
        margin-right: 10px;
      }
    }
  }
  .no-orders {
    margin-top: 10px;
    margin-bottom: 10px;
    img {
      width: 100%;
      padding: 0px 10px;
    }
  }
  .dispatch {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
  }
  .drivers {
    display: flex;
    align-items: stretch;
    justify-content: center;
    height: calc(100vh - 14em);
    overflow-y: scroll;
    flex-wrap: wrap;
    &.all {
      width: 500px;
      .driver {
        width: 100%;
        margin: 0;
      }
    }
    .driver {
      background: transparent;
      width: 100%;
      overflow: hidden;
      margin-bottom: 20px;
      .name {
        color: #25396F;
        padding: 10px 0px;
        border-radius: 10px;
        text-align: left;
        font-weight: 400;
      }
      .transition {
        min-height: 100px;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start;
      }
    }
  }
  .rest {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    overflow: auto;
    flex-wrap: wrap;
    margin-top: 20px;
    margin-bottom: 20px;
   .name {
      margin-bottom: 20px;
      background: #5e35b1;
      color: #fff;
      padding: 10px;
      border-radius: 10px;
      text-align: center;
    }
  }
  .row.grouped {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
  }
  .col-order.ungrouped {
    max-width: 40%;
  }
  .sugestion-box,
  .formated-group {
    display: flex;
    flex-flow: wrap;
  }
  .orders_delivered {
    color: #25396F;
    padding: 10px;
    border-radius: 10px;
    text-align: left;
    font-weight: 400;
    // width: 500px;
    margin-top: 20px;
  }
  .offline {
    padding: 10px;
    width: 350px;
    display: inline-block;
  }
  .col-order {
    flex: 1;
    margin: 5px;
    padding: 0px;
    border-radius: 4px;
    min-width: 350px;
    max-width: 350px;
  }
  .order-card {
    background: #fff;
    margin: 5px;
    padding: 4px 0px;
    border: 1px solid #D9E6F8;
    border-radius: 16px;
    position: relative;
    cursor: pointer;
  }
  button.close-btn {
    background: #fff;
    border-radius: 50px;
    width: 20px;
    height: 20px;
    color: red;
    border: 1px solid red;
    line-height: 20px;
    padding: 0px;
    position: absolute;
    right: -7px;
    top: -7px;
  }
  .order-top {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #D9E6F8;
    padding: 5px;
  }
  .örderId p {
    background: #F4F6FF;
    padding: 3px;
    border-radius: 7px;
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 2px;
  }
  .örderId p:hover {
    border: 1px solid #674BD2;
  }
  .orderDate span {
    font-size: 13px;
    color: #25396F;
  }
  .ord-client {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    padding: 5px;
    margin-top: 0px;
    font-size: 14px;
    background: #fff;
    border-radius: 18px;
    position: relative;
  }
  .ord-client .client {
    margin: 5px 0px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    /* width: 40%; */
  }
  .ord-client .address span.zone {
    display: block;
  }
  .ungrouped-title p{
    padding-bottom: 10px;
    border-bottom: 1px solid #D9E6F8;
    text-align: center;
  }
  .group-card {
    background: #E6EFFB;
    margin-bottom: 20px;
    border-radius: 20px;
    border: 1px solid #D9E6F8;
    position: relative;
    margin-left: 10px;
    margin-right: 10px;
    cursor: pointer;
    padding: 10px;
    padding-top: 5px;
  }
  .col-order.separator {
    border-left: 1px solid #D9E6F8;
    margin: 20px 0;
    max-width: 0px;
    min-width: 0px;
  }
  .col-order.grouped {
    min-width: 60%;
  }
  .saveGrouped {
    display: flex;
    justify-content: end;
  }
  .group-header {
    margin: 0px;
    display: flex;
    align-items: center;
    border-right: none;
    justify-content: space-between;
  }
  .group-header p{
    margin-bottom: 0px;
  }
  .box-ungrouped {
    display: flex;
    width: 100%;
    flex-flow: wrap;
  }
  .address_shipping span.ellipsis-text {
    display: inline-block;
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
  .overflow-box {
    height: 750px;
    overflow: auto;
  }
  .posibleGroup .group-card {
    border: 1px solid #17B086;
  }
  .grouped-orders {
    display: flex;
    width: 100%;
    flex-flow: wrap;
  }
  .sugestion-flag {
    margin: 0 10px;
  }
  .sugestion-flag p {
    color: #17B086;
    font-size: 15px;
    font-weight: 400;
  }
  .order-card.suggested-order {
    border: 1px solid #17B086;
    border-radius: 10px;
  }
  button.plus-btn {
    background: #fff;
    border-radius: 50px;
    width: 20px;
    height: 20px;
    color: #17B086;
    border: 1px solid #17B086;
    line-height: 20px;
    padding: 0px;
    position: absolute;
    right: -7px;
    top: -7px;
  }
  .box-inline-groups {
    display: flex;
    flex-wrap: wrap;
  }
  .grouped-orders .group-header {
    justify-content: left;
    padding-left: 10px;
  }
  .group-card.has-suggestions {
    border: 1px solid #17B086;
  }
  .groups-container {
    span.bached {
    background: #17B086;
    color: #fff;
    }
    .ord {
      p {
        display: inline-block;
        font-size: 14px;
        font-weight: 500;
        text-transform: capitalize;
        color: #000;
        background-color: #fff;
        border: none;
        opacity: 1;
        padding: 3px 2px !important;
        margin: 3px;
        border-radius: 14px;
        cursor: pointer;
      }
      p.status-prepared {
        // background-color: #5e35b1;
        color: #5e35b1;
      }
      p.status-processing {
        // background-color: #F3BB45;
        color: #F3BB45;
      }
      p.status-new {
        // background-color: #68B3C8;
        color: #68B3C8;
      }
    }
  }

</style>
<style lang="scss">
  .dispatch-filters-content {
    background: #fff;
    margin-bottom: 10px;
  }

  .dispatch-filters-content .filter-selection {
    display: inline-block;
    margin-right: 8px;
    margin-bottom: 3px;
    padding: 4px 4px !important;
    background: #f0f0f0;
    border-radius: 4px;
    font-size: 12px;
  }

  .dispatch-filters-content .reset-filters-link {
    margin-left: 10px;
    color: #409eff;
    text-decoration: none;
  }

  .dispatch-filters-content .filters-header {
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 5px;
  }

  .dispatch-filters-content .collapse-toggle-btn {
    background: #409eff;
    border: none;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    color: white;
    flex-shrink: 0;
  }

  .vm--container.dispatch-filters-modal {
    max-width: 100%;
    overflow-x: hidden;
  }

  .vm--container.dispatch-filters-modal .filters-grid {
    display: grid;
    grid-template-columns: 60% 40%;
    gap: 20px;
    overflow-x: hidden;
    width: 100%;
    box-sizing: border-box;
  }

  .vm--container.dispatch-filters-modal .modal-column-left,
  .vm--container.dispatch-filters-modal .modal-column-right {
    max-height: 600px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 15px;
    box-sizing: border-box;
  }

  .vm--container.dispatch-filters-modal .card {
    margin-bottom: 0 !important;
  }

  .vm--container.dispatch-filters-modal .card-content {
    padding: 10px !important;
    overflow-x: hidden;
  }

  .vm--container.dispatch-filters-modal .slim-header {
    padding: 6px 10px !important;
    border-bottom: 1px solid #e6e6e6;
  }

  .vm--container.dispatch-filters-modal .slim-header h4 {
    margin: 0;
  }

  .vm--container.dispatch-filters-modal .slim-body {
    padding: 8px !important;
    overflow-x: hidden;
  }

  .vm--container.dispatch-filters-modal .slim-footer {
    text-align: right;
    margin-top: 8px;
    border-top: 1px solid #eee;
    padding-top: 6px;
    padding-bottom: 0 !important;
    padding-left: 15px !important;
    padding-right: 0 !important;
  }

  .vm--container.dispatch-filters-modal .filter-section {
    margin-bottom: 14px;
  }

  .vm--container.dispatch-filters-modal .filter-section h6 {
    margin-bottom: 8px;
    font-weight: 500;
  }

  .vm--container.dispatch-filters-modal .button-group-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter {
    min-width: 120px;
    padding: 10px 23px;
    border-radius: 50px;
    height: 40px;
    line-height: 19px;
    font-size: 14px;
    font-weight: 400;
    border-color: white;
    white-space: nowrap;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    text-transform: none !important;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter.btn-default {
    background: #f0f0f0 !important;
    color: #666 !important;
    border: 1px solid #ddd !important;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter.current {
    color: white !important;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter.current.NEW {
    background-color: #0097FC !important;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter.current.PROCESSING {
    background-color: #F3BB45 !important;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter.current.PREPARED {
    background-color: #5e35b1 !important;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter.current.TRANSPORT {
    background-color: #0f566a !important;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter.current.AWAITING_TRANSPORT {
    background-color: #ffc107 !important;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter.current.PICKED_UP_BY_DELIVERY {
    background-color: #66615B !important;
  }

  .vm--container.dispatch-filters-modal .range-row {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  @media (max-width: 768px) {
    .vm--container.dispatch-filters-modal .filters-grid {
      grid-template-columns: 1fr;
    }

    .vm--container.dispatch-filters-modal .modal-column-left,
    .vm--container.dispatch-filters-modal .modal-column-right {
      max-height: none;
      padding-right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dispatch/DispatchView.vue